/* eslint-disable no-underscore-dangle */
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { AlertsTypesFilterValues, AlertsDeviceTypesFilterValues, ADMIN, SUPER_ADMIN } from '../constants/variables';

export const generateRebalancingAllRegionsDeficitExcessMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Агрегированный баланс самокатов на парковках`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>hex_id</td>
                <td class="col_val">${features[0].properties.hex_id}</td>
            </tr>
            <tr>
                <td>${t`Абсолютный избыток`}(+) / ${t`дефицит`}(-)</td>
                <td class="col_val">${features[0].properties.deficit_excess_count_agg}</td>
            </tr>
        </table>
    `
);

export const generateStartCountMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Агрегированные старты треков`}
                </strong></td>
            </tr>
        <table cellspacing=7px>
          <col>
          <colgroup span="2"></colgroup>
          <colgroup span="2"></colgroup>
          <tr>
            <td rowspan="2"></td>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`1 день`}</th>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${7} дней`}</th>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${30} дней`}</th>
          </tr>
          <tr>
            <th scope="col">abs</th>
            <th scope="col">%</th>
            <th scope="col">abs</th>
            <th scope="col">%</th>
            <th scope="col">abs</th>
            <th scope="col">%</th>
          </tr>
          <tr>
            <th scope="row">${t`Старты`}</th>
            <td class="col_val">${features[0].properties.start_count_1d}</td>
            <td class="col_val">${features[0].properties.start_count_1d_sh}</td>
            <td class="col_val">${features[0].properties.start_count_7d}</td>
            <td class="col_val">${features[0].properties.start_count_7d_sh}</td>
            <td class="col_val">${features[0].properties.start_count_30d}</td>
            <td class="col_val">${features[0].properties.start_count_30d_sh}</td>
          </tr>
          <tr>
            <th scope="row">${t`Финиши`}</th>
            <td class="col_val">${features[0].properties.finish_count_1d}</td>
            <td class="col_val">${features[0].properties.finish_count_1d_sh}</td>
            <td class="col_val">${features[0].properties.finish_count_7d}</td>
            <td class="col_val">${features[0].properties.finish_count_7d_sh}</td>
            <td class="col_val">${features[0].properties.finish_count_30d}</td>
            <td class="col_val">${features[0].properties.finish_count_30d_sh}</td>
          </tr>
        </table>
    `
);

export const generateStartCompetitorsCountMessage = features => {
    const properties = features[0].properties;
    const allZero = arr => arr.every(value => Number(value) === 0);
    const rows = [
        {
            name: t`Whoosh`,
            values: [
                properties.starts_whoosh_1d, properties.ms_whoosh_1d,
                properties.starts_whoosh_7d, properties.ms_whoosh_7d,
                properties.starts_whoosh_30d, properties.ms_whoosh_30d,
            ],
        },
        {
            name: t`Yandex`,
            values: [
                properties.starts_yandex_1d, properties.ms_yandex_1d,
                properties.starts_yandex_7d, properties.ms_yandex_7d,
                properties.starts_yandex_30d, properties.ms_yandex_30d,
            ],
        },
        {
            name: t`Urent`,
            values: [
                properties.starts_urent_1d, properties.ms_urent_1d,
                properties.starts_urent_7d, properties.ms_urent_7d,
                properties.starts_urent_30d, properties.ms_urent_30d,
            ],
        },
        {
            name: t`Jet`,
            values: [
                properties.starts_jet_1d, properties.ms_jet_1d,
                properties.starts_jet_7d, properties.ms_jet_7d,
                properties.starts_jet_30d, properties.ms_jet_30d,
            ],
        },
        {
            name: t`Eleven`,
            values: [
                properties.starts_eleven_1d, properties.ms_eleven_1d,
                properties.starts_eleven_7d, properties.ms_eleven_7d,
                properties.starts_eleven_30d, properties.ms_eleven_30d,
            ],
        },
        {
            name: t`Lime`,
            values: [
                properties.starts_lime_1d, properties.ms_lime_1d,
                properties.starts_lime_7d, properties.ms_lime_7d,
                properties.starts_lime_30d, properties.ms_lime_30d,
            ],
        },
    ];
    const nonZeroRows = rows.filter(row => !allZero(row.values));
    const tableRows = nonZeroRows.map(row => (
      `<tr>
        <th scope="row">${row.name}</th>
        <td class="col_val">${row.values[0]}</td>
        <td class="col_val">${row.values[1]}</td>
        <td class="col_val">${row.values[2]}</td>
        <td class="col_val">${row.values[3]}</td>
        <td class="col_val">${row.values[4]}</td>
        <td class="col_val">${row.values[5]}</td>
      </tr>`
    )).join('');

    return `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Агрегированные старты`}
                </strong></td>
            </tr>
      <table cellspacing=7px>
        <col>
        <colgroup span="2"></colgroup>
        <colgroup span="2"></colgroup>
        <tr>
          <td rowspan="2"></td>
          <th colspan="2" style="text-align:left" scope="colgroup">${t`1 день`}</th>
          <th colspan="2" style="text-align:left" scope="colgroup">${t`${7} дней`}</th>
          <th colspan="2" style="text-align:left" scope="colgroup">${t`${30} дней`}</th>
        </tr>
        <tr>
          <th scope="col">abs</th>
          <th scope="col">%</th>
          <th scope="col">abs</th>
          <th scope="col">%</th>
          <th scope="col">abs</th>
          <th scope="col">%</th>
        </tr>
        ${tableRows}
      </table>
    `;
};

export const generateOaStartCompetitorsCountMessage = features => {
    const properties = features[0].properties;
    const allZero = arr => arr.every(value => Number(value) === 0);
    const rows = [
        {
            name: t`Whoosh`,
            values: [
                properties.period_trips_whoosh, properties.whoosh_market_share,
            ],
        },
        {
            name: t`Yandex`,
            values: [
                properties.period_trips_yandex, properties.yandex_market_share,
            ],
        },
        {
            name: t`Urent`,
            values: [
                properties.period_trips_urent, properties.urent_market_share,
            ],
        },
        {
            name: t`Jet`,
            values: [
                properties.period_trips_jet, properties.jet_market_share,
            ],
        },
        {
            name: t`Eleven`,
            values: [
                properties.period_trips_eleven, properties.eleven_market_share,
            ],
        },
        {
            name: t`Lime`,
            values: [
                properties.period_trips_lime, properties.lime_market_share,
            ],
        },
        {
            name: t`Lite`,
            values: [
                properties.period_trips_lite, properties.lite_market_share,
            ],
        },
    ];
    const nonZeroRows = rows.filter(row => !allZero(row.values));
    const tableRows = nonZeroRows.map(row => (
      `<tr>
        <th scope="row">${row.name}</th>

        <td class="col_val">${row.values[0]}</td>
        <td class="col_val">${row.values[1]}</td>
      </tr>`
    )).join('');

    return `
      <table cellspacing=7px>
        <tr>
          <td rowspan="2"></td>
        </tr>
        <tr>
          <th scope="col">${t`Стартов`}</th>
          <th scope="col">${t`Доля рынка, %`}</th>
        </tr>
        ${tableRows}
      </table>
    `;
};

export const generateOaRotationCountMessage = (features, userGroups = []) => {
    const properties = features[0].properties;
    const allZero = arr => arr.every(value => value === null || Number(value) === 0);
    const rows = [
        {
            name: t`Whoosh`,
            isWhoosh: true,
            color: 'orange',
            values: [
                properties.rotation_whoosh,
                properties.trips_count_whoosh,
                properties.trips_count_whoosh_avg,
                properties.available_fleet_whoosh_avg,
            ],
        },
        {
            name: t`Yandex`,
            color: '#f8f32b',
            values: [
                properties.rotation_yandex,
                properties.trips_count_yandex,
                properties.trips_count_yandex_avg,
                properties.available_fleet_yandex_avg,
            ],
        },
        {
            name: t`Urent`,
            color: '#804cff',
            values: [
                properties.rotation_urent,
                properties.trips_count_urent,
                properties.trips_count_urent_avg,
                properties.available_fleet_urent_avg,
            ],
        },
        {
            name: t`Jet`,
            color: '#2f7fe2',
            values: [
                properties.rotation_jet,
                properties.trips_count_jet,
                properties.trips_count_jet_avg,
                properties.available_fleet_jet_avg,
            ],
        },
        // DA-16160: gojet — Jet в Сан-Педро-Гарса-Гарсия под отдельным псевдонимом подрядчика
        {
            name: t`GoJet`,
            color: '#2f7fe2',
            values: [
                properties.rotation_gojet,
                properties.trips_count_gojet,
                properties.trips_count_gojet_avg,
                properties.available_fleet_gojet_avg,
            ],
        },
        {
            name: t`Eleven`,
            color: '#0091ad',
            values: [
                properties.rotation_eleven,
                properties.trips_count_eleven,
                properties.trips_count_eleven_avg,
                properties.available_fleet_eleven_avg,
            ],
        },
        {
            name: t`Lime`,
            color: '#00dd01',
            values: [
                properties.rotation_lime,
                properties.trips_count_lime,
                properties.trips_count_lime_avg,
                properties.available_fleet_lime_avg,
            ],
        },
        {
            name: t`Lite`,
            color: '#027bff',
            values: [
                properties.rotation_lite,
                properties.trips_count_lite,
                properties.trips_count_lite_avg,
                properties.available_fleet_lite_avg,
            ],
        },
    ];

    let filteredRows = rows;
    if (userGroups.includes(ADMIN) && !userGroups.includes(SUPER_ADMIN)) {
        filteredRows = rows.filter(row => row.isWhoosh);
    }

    const nonZeroRows = filteredRows.filter(row => !allZero(row.values));
    const maxValues = [
        Math.max(...nonZeroRows.map(row => row.values[0]), 1),
        Math.max(...nonZeroRows.map(row => row.values[1]), 1),
        Math.max(...nonZeroRows.map(row => row.values[2]), 1),
        Math.max(...nonZeroRows.map(row => row.values[3]), 1),
    ];
    const tableCells = maxValues.map((maxValue, colIndex) => {
        const cellTitle = [
            t`Rotation`,
            t`Стартов`,
            t`Стартов в день`,
            t`Доступный флот`,
        ][colIndex];
        const chartBars = nonZeroRows.map(row => {
            const value = row.values[colIndex];
            if (value === null) return '';
            const height = (value / maxValue) * 40;

            return `
                <div class="chart-column">
                    <div class="chart-bar" 
                         style="height: ${height}px; background-color: ${row.color}"
                         title="${row.name}: ${value}">
                    </div>
                    <div class="chart-value">${value}</div>
                </div>
            `;
        }).join('');

        return `
            <div class="chart-cell">
                <div class="cell-title">${cellTitle}</div>
                <div class="chart-container">
                    ${chartBars}
                </div>
            </div>
        `;
    }).join('');

    return `
        <style>
            .chart-table {
                display: grid;
                grid-template-columns: repeat(2, 1fr);  /* 2 столбца */
                gap: 12px;
                font-size: 12px;
            }
            .chart-cell {
                display: flex;
                flex-direction: column;
                align-items: center;
                border: 1px solid #eee;
                border-radius: 4px;
                padding: 6px;
                min-width: 130px;
            }
            .cell-title {
                font-weight: bold;
                margin-bottom: 6px;
                text-align: center;
            }
            .chart-container {
                display: flex;
                flex-direction: row;
                justify-content: center;
                gap: 8px;
                width: 100%;
            }
            .chart-column {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end; /* добавлено: выравнивание по низу */
                height: 60px; /* добавлено: ограниченная высота */
            }
            .chart-bar {
                width: 20px;
                border-radius: 3px 3px 0 0;
                transition: height 0.3s;
            }
            .chart-value {
                font-size: 10px;
                margin-top: 0;
                font-weight: bold;
            }
            .chart-name {
                font-size: 10px;
                text-align: center;
                margin-top: 2px;
                white-space: nowrap;
            }
        </style>
         <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Операционные зоны (Rotation)`}
                </strong></td>
        <table class="popup">
        <tr>
        <td>${t`Название зоны`}</td>
        <td class="col_val">${(typeof features[0].properties.oa_name == 'undefined') ? '-' : features[0].properties.oa_name}</td>
        </tr>
        <tr>
        <td>${t`ID`}</td>
        <td class="col_val">${(typeof features[0].properties.oa_id == 'undefined') ? '-' : features[0].properties.oa_id}</td>
        </tr>
        <td style="font-weight: bold;">${t`Средний таргет на зону (9 утра)`}</td>
        <td class="col_val" style="font-weight: bold;">${(typeof features[0].properties.target_total_9am_weekday_avg == 'undefined') ? '-' : features[0].properties.target_total_9am_weekday_avg}</td>
        </tr>
        <tr>
        <td>${t`Период`}</td>
        <td class="col_val">${(typeof features[0].properties.period_ == 'undefined') ? '-' : features[0].properties.period_} ${t`дн.`}</td>
        </tr>
        </table>
        <div class="chart-table">
            ${tableCells}
        </div>
    `;
};


export const generateOaRotationCountMessageDev = (features, userGroups = []) => {
    const properties = features[0].properties;
    const allZero = arr => arr.every(value => value === null || Number(value) === 0);
    const rows = [
        {
            name: t`Whoosh`,
            isWhoosh: true,
            color: 'orange',
            values: [
                properties.rotation_whoosh,
                properties.trips_count_whoosh,
                properties.trips_count_whoosh_avg,
                properties.available_fleet_whoosh_avg,
            ],
        },
        {
            name: 'Whoosh v2',
            isWhoosh: true,
            color: 'orange',
            values: [
                properties.rotation_whoosh_v2 !== null && typeof properties.rotation_whoosh_v2 !== 'undefined'
                    ? parseFloat(properties.rotation_whoosh_v2).toFixed(1)
                    : null,
                properties.trips_count_whoosh_v2 !== null && typeof properties.trips_count_whoosh_v2 !== 'undefined'
                    ? properties.trips_count_whoosh_v2
                    : null,
                (properties.trips_count_whoosh_v2 && properties.period_)
                    ? Math.round(properties.trips_count_whoosh_v2 / properties.period_)
                    : null,
                properties.available_fleet_whoosh_v2_avg
                    ? Math.round(properties.available_fleet_whoosh_v2_avg)
                    : null,
            ],
        },
        {
            name: 'Whoosh v3',
            isWhoosh: true,
            color: 'orange',
            values: [
                properties.rotation_whoosh_v3 !== null && typeof properties.rotation_whoosh_v3 !== 'undefined'
                    ? parseFloat(properties.rotation_whoosh_v3).toFixed(1)
                    : null,
                properties.trips_count_whoosh_v3 !== null && typeof properties.trips_count_whoosh_v3 !== 'undefined'
                    ? properties.trips_count_whoosh_v3
                    : null,
                (properties.trips_count_whoosh_v3 && properties.period_)
                    ? Math.round(properties.trips_count_whoosh_v3 / properties.period_)
                    : null,
                properties.available_fleet_whoosh_v2_avg
                    ? Math.round(properties.available_fleet_whoosh_v2_avg)
                    : null,
            ],
        },
        {
            name: t`Yandex`,
            color: '#f8f32b',
            values: [
                properties.rotation_yandex,
                properties.trips_count_yandex,
                properties.trips_count_yandex_avg,
                properties.available_fleet_yandex_avg,
            ],
        },
        {
            name: t`Urent`,
            color: '#804cff',
            values: [
                properties.rotation_urent,
                properties.trips_count_urent,
                properties.trips_count_urent_avg,
                properties.available_fleet_urent_avg,
            ],
        },
        {
            name: t`Jet`,
            color: '#2f7fe2',
            values: [
                properties.rotation_jet,
                properties.trips_count_jet,
                properties.trips_count_jet_avg,
                properties.available_fleet_jet_avg,
            ],
        },
        // DA-16160: gojet — Jet в Сан-Педро-Гарса-Гарсия под отдельным псевдонимом подрядчика
        {
            name: t`GoJet`,
            color: '#2f7fe2',
            values: [
                properties.rotation_gojet,
                properties.trips_count_gojet,
                properties.trips_count_gojet_avg,
                properties.available_fleet_gojet_avg,
            ],
        },
        {
            name: t`Eleven`,
            color: '#0091ad',
            values: [
                properties.rotation_eleven,
                properties.trips_count_eleven,
                properties.trips_count_eleven_avg,
                properties.available_fleet_eleven_avg,
            ],
        },
        {
            name: t`Lime`,
            color: '#00dd01',
            values: [
                properties.rotation_lime,
                properties.trips_count_lime,
                properties.trips_count_lime_avg,
                properties.available_fleet_lime_avg,
            ],
        },
        {
            name: t`Lite`,
            color: '#027bff',
            values: [
                properties.rotation_lite,
                properties.trips_count_lite,
                properties.trips_count_lite_avg,
                properties.available_fleet_lite_avg,
            ],
        },
    ];

    let filteredRows = rows;
    if (userGroups.includes(ADMIN) && !userGroups.includes(SUPER_ADMIN)) {
        filteredRows = rows.filter(row => row.isWhoosh);
    }

    const nonZeroRows = filteredRows.filter(row => !allZero(row.values));
    const maxValues = [
        Math.max(...nonZeroRows.map(row => row.values[0]), 1),
        Math.max(...nonZeroRows.map(row => row.values[1]), 1),
        Math.max(...nonZeroRows.map(row => row.values[2]), 1),
        Math.max(...nonZeroRows.map(row => row.values[3]), 1),
    ];
    const tableCells = maxValues.map((maxValue, colIndex) => {
        const cellTitle = [
            t`Rotation`,
            t`Стартов`,
            t`Стартов в день`,
            t`Доступный флот`,
        ][colIndex];
        const chartBars = nonZeroRows.map(row => {
            const value = row.values[colIndex];
            if (value === null) return '';
            const height = (value / maxValue) * 40;
            return `
                <div class="chart-column">
                    <div class="chart-bar"
                         style="height: ${height}px; background-color: ${row.color}"
                         title="${row.name}: ${value}">
                    </div>
                    <div class="chart-value">${value}</div>
                </div>
            `;
        }).join('');
        return `
            <div class="chart-cell">
                <div class="cell-title">${cellTitle}</div>
                <div class="chart-container">
                    ${chartBars}
                </div>
            </div>
        `;
    }).join('');

    return `
        <style>
            .chart-table {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 12px;
                font-size: 12px;
            }
            .chart-cell {
                display: flex;
                flex-direction: column;
                align-items: center;
                border: 1px solid #eee;
                border-radius: 4px;
                padding: 6px;
                min-width: 130px;
            }
            .cell-title {
                font-weight: bold;
                margin-bottom: 6px;
                text-align: center;
            }
            .chart-container {
                display: flex;
                flex-direction: row;
                justify-content: center;
                gap: 8px;
                width: 100%;
            }
            .chart-column {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                height: 60px;
            }
            .chart-bar {
                width: 20px;
                border-radius: 3px 3px 0 0;
                transition: height 0.3s;
            }
            .chart-value {
                font-size: 10px;
                margin-top: 0;
                font-weight: bold;
            }
            .chart-name {
                font-size: 10px;
                text-align: center;
                margin-top: 2px;
                white-space: nowrap;
            }
        </style>
         <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Операционные зоны (Rotation)`}
                </strong></td>
        <table class="popup">
        <tr>
        <td>${t`Название зоны`}</td>
        <td class="col_val">${(typeof features[0].properties.oa_name == 'undefined') ? '-' : features[0].properties.oa_name}</td>
        </tr>
        <tr>
        <td>${t`ID`}</td>
        <td class="col_val">${(typeof features[0].properties.oa_id == 'undefined') ? '-' : features[0].properties.oa_id}</td>
        </tr>
        <td style="font-weight: bold;">${t`Средний таргет на зону (9 утра)`}</td>
        <td class="col_val" style="font-weight: bold;">${(typeof features[0].properties.target_total_9am_weekday_avg == 'undefined') ? '-' : features[0].properties.target_total_9am_weekday_avg}</td>
        </tr>
        <tr>
        <td>${t`Период`}</td>
        <td class="col_val">${(typeof features[0].properties.period_ == 'undefined') ? '-' : features[0].properties.period_} ${t`дн.`}</td>
        </tr>
        </table>
        <div class="chart-table">
            ${tableCells}
        </div>
    `;
};

export const generatePopulationMessage = features => (
    `<tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Население`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`Население в ячейке`}</td>
            </tr>
            <tr><td class="col_val">${features[0].properties.population}</td></tr>
        </table>
    `
);

export const generateFinishCountMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Агрегированные финиши треков`}
                </strong></td>
            </tr>
        <table cellspacing=7px>
          <col>
          <colgroup span="2"></colgroup>
          <colgroup span="2"></colgroup>
          <tr>
            <td rowspan="2"></td>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`1 день`}</th>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${7} дней`}</th>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${30} дней`}</th>
          </tr>
          <tr>
            <th scope="col">abs</th>
            <th scope="col">%</th>
            <th scope="col">abs</th>
            <th scope="col">%</th>
            <th scope="col">abs</th>
            <th scope="col">%</th>
          </tr>
          <tr>
            <th scope="row">${t`Старты`}</th>
            <td class="col_val">${features[0].properties.start_count_1d}</td>
            <td class="col_val">${features[0].properties.start_count_1d_sh}</td>
            <td class="col_val">${features[0].properties.start_count_7d}</td>
            <td class="col_val">${features[0].properties.start_count_7d_sh}</td>
            <td class="col_val">${features[0].properties.start_count_30d}</td>
            <td class="col_val">${features[0].properties.start_count_30d_sh}</td>
          </tr>
          <tr>
            <th scope="row">${t`Финиши`}</th>
            <td class="col_val">${features[0].properties.finish_count_1d}</td>
            <td class="col_val">${features[0].properties.finish_count_1d_sh}</td>
            <td class="col_val">${features[0].properties.finish_count_7d}</td>
            <td class="col_val">${features[0].properties.finish_count_7d_sh}</td>
            <td class="col_val">${features[0].properties.finish_count_30d}</td>
            <td class="col_val">${features[0].properties.finish_count_30d_sh}</td>
          </tr>
        </table>
    `
);
// Taps
export const generateUserTapsCountMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Тапы пользователей`}
                </strong></td>
            </tr>
        <table cellspacing=7px>
          <col>
          <colgroup span="2"></colgroup>
          <colgroup span="2"></colgroup>
          <tr>
            <td rowspan="1"></td>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${7} дней`}</th>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${30} дней`}</th>
          </tr>
          <tr>
          <th scope="row">${t`Открытия`}</th>
          <td class="col_val" style="text-align:right">${features[0].properties.opens_sum_7d}</td>
          <td class="col_val" style="text-align:right">${features[0].properties.opens_sum_30d}</td>
        </tr>
        <tr>
          <th scope="row">${t`Открытия, %`}</th>
          <td class="col_val" style="text-align:right">${features[0].properties.opens_sum_7d_sh}</td>
          <td class="col_val" style="text-align:right">${features[0].properties.opens_sum_30d_sh}</td>
        </tr>
          <tr>
            <th scope="row">${t`Тапы`}</th>
            <td class="col_val" style="text-align:right">${features[0].properties.taps_sum_7d}</td>
            <td class="col_val" style="text-align:right">${features[0].properties.taps_sum_30d}</td>
          </tr>
          <tr>
          <th scope="row">${t` Тапы, %`}</th>
          <td class="col_val" style="text-align:right">${features[0].properties.taps_sum_7d_sh}</td>
          <td class="col_val" style="text-align:right">${features[0].properties.taps_sum_30d_sh}</td>
        </tr>
          <tr>
            <th scope="row">${t`Старты`}</th>
            <td class="col_val" style="text-align:right">${features[0].properties.starts_sum_7d}</td>
            <td class="col_val" style="text-align:right">${features[0].properties.starts_sum_30d}</td>
          </tr>
          <tr>
            <th scope="row">${t`Открытий для старта`}</th>
            <td class="col_val" style="text-align:right">${features[0].properties.open_to_ride_7d}</td>
            <td class="col_val" style="text-align:right">${features[0].properties.open_to_ride_30d}</td>
          </tr>
        </table>
        <table class="popup">
        <tr>
            <td>hex_id</td>
            <td class="col_val">${features[0].properties.hex_id}</td>
        </tr>
    </table>

    `
);
// Clustered Taps & opens
export const generateClusteredTapsOpensCountMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Кластеризированные открытия (7 дней)`}
                </strong></td>
            </tr>
        <table cellspacing=7px>
          <col>
          <colgroup span="2"></colgroup>
          <colgroup span="2"></colgroup>
          <tr>
            <td rowspan="1"></td>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${7} дней`}</th>
            <th colspan="2" style="text-align:left" scope="colgroup">${t`${30} дней`}</th>
          </tr>
          <tr>
          <th scope="row">${t`Открытия`}</th>
          <td class="col_val" style="text-align:right">${features[0].properties.opens_sum_7d}</td>
          <td class="col_val" style="text-align:right">${features[0].properties.opens_sum_30d}</td>
        </tr>
          <tr>
            <th scope="row">${t`Тапы`}</th>
            <td class="col_val" style="text-align:right">${features[0].properties.taps_sum_7d}</td>
            <td class="col_val" style="text-align:right">${features[0].properties.taps_sum_30d}</td>
          </tr>
        </table>
    `
);
export const generateUserTapsOpensHistCountMessage = features => {
    const properties = features[0].properties;
    const years = [ 2024, 2025, 2026 ];
    const rows = [
        [ t`Открытия`, 'opens_sum' ],
        [ t`Открытия, %`, 'opens_sum', '_sh' ],
        [ t`Тапы`, 'taps_sum' ],
        [ t`Тапы, %`, 'taps_sum', '_sh' ],
        [ t`Старты`, 'starts_sum' ],
        [ t`Открытий для старта`, 'open_to_ride' ],
    ];

    return `
    <tr>
        <td></td>
        <td style="text-align: center; vertical-align: middle;"><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Исторические тапы и открытия`}
        </strong></td>
    </tr>
    <table cellspacing="7px" style="border-collapse: collapse; width: 100%;">
        <col>
        <tr>
            <td rowspan="1"></td>
            ${years.map(year => `<th style="text-align: center" scope="col">${year}</th>`).join('')}
        </tr>
        ${rows.map(([ label, prefix, suffix = '' ]) => `
            <tr>
                <th scope="row" style="text-align: center">${label}</th>
                ${years.map(year => {
        const value = properties[`${prefix}_${year}d${suffix}`];
        return `<td class="col_val" style="text-align: center">${typeof value === 'undefined' ? '-' : value}</td>`;
    }).join('')}
            </tr>`).join('')}
    </table>
    <table class="popup" style="border-collapse: collapse; width: 100%;">
        <tr>
            <td style="text-align: center; vertical-align: middle;">hex_id</td>
            <td class="col_val" style="text-align: center; vertical-align: middle;">${properties.hex_id}</td>
        </tr>
    </table>
    `;
};

export const generateDiffStartFinishMessage = features => (
    `
     <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Агрегированая разница стартов и финишей за 7 дней`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>hex_id</td>
                <td class="col_val">${features[0].properties.hex_id}</td>
            </tr>
            <tr>
                <td>${t`Количество стартов в ячейке за 7 дней`}</td>
                <td class="col_val">${features[0].properties.start_count_7d}</td>
            </tr>
            <tr>
                <td>${t`Количество финишей в ячейке за 7 дней`}</td>
                <td class="col_val">${features[0].properties.finish_count_7d}</td>
            </tr>
            <tr>
                <td>${t`Разница`}</td>
                <td class="col_val">${features[0].properties.sf_diff_7d}</td>
            </tr>
        </table>
    `
);

export const generateAggFailedTripsMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Неудачные старты (7 дней)`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>hex_id</td>
                <td class="col_val">${features[0].properties.hex_id}</td>
            </tr>
            <tr>
                <td>${t`Количество стартов`}</td>
                <td class="col_val">${features[0].properties.trips}</td>
            </tr>
            <tr>
                <td>${t`Количество неудачных стартов`}</td>
                <td class="col_val">${features[0].properties.failed_trips}</td>
            </tr>
            <tr>
                <td>${t`Доля неудачных стартов`}</td>
                <td class="col_val">${features[0].properties.perc_ftrips}</td>
            </tr>
        </table>
    `
);

export const generateServiceCentersMessage = features => {
    const properties = features[0].properties;
    const time = properties.time === 2 ? t`15 (самокат)` : t`${properties.time} (авто)`;


    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Изохроны доступности сервисных центров`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>ID</td>
                <td class="col_val">${typeof properties.id === 'undefined' ? '-' : properties.id}</td>
            </tr>
            <tr>
                <td>${t`Название`}</td>
                <td class="col_val">${typeof properties.name === 'undefined' ? '-' : properties.name}</td>
            </tr>
            <tr>
                <td>${t`Тип`}</td>
                <td class="col_val">${typeof properties.type === 'undefined' ? '-' : properties.type}</td>
            </tr>
            <tr>
                <td>${t`Время`}</td>
                <td class="col_val">${typeof properties.time === 'undefined' ? '-' : time}</td>
            </tr>
        </table>
    `;
};


export const generateReabalanceForecastMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Прогноз ребаланса парковок`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                ${
                    features[0].properties.rebalance_actual < 0 ?
                    `<td><big><strong>${t`Избыток самокатов`}</big></strong></td>` :
                    `<td><big><strong>${t`Недостаток самокатов`}</big></strong></td>`
                }
                <td class="col_val"><big><strong>${Math.abs(features[0].properties.rebalance_actual)}</big></strong></td>
            </tr>
            <tr>
            <td>${t`Самокатов на парковке`}</td>
            <td class="col_val">${features[0].properties.actual_count}</td>
            </tr>
            <tr>
                <td>${t`Расчет прогноза от`}</td>
                <td class="col_val">${features[0].properties.ds}</td>
            </tr>
            <tr>
                <td>${t`Актуально на`}</td>
                <td class="col_val">${features[0].properties.ds_local}</td>
            </tr>
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Класс парковки`}</td>
                <td class="col_val">${features[0].properties.class_}</td>
            </tr>
        </table>
    `
);

export const generateParkings1300Message = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Парковки (1300)`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}: </td>
                <td class="col_val">${features[0].properties.id}</td>
            </tr>
            <tr>
            <td>${t`Внутренний ID парковки`}: </td>
                <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
            </tr>
            <tr>
                <td>${t`Статус по 1300`}: </td>
                <td class="col_val">${(typeof features[0].properties.status_1300 == 'undefined') ? '-' : features[0].properties.status_1300}</td>
            </tr>
            <tr>
                <td>${t`Причина отказа`}: </td>
                <td class="col_val">${(typeof features[0].properties.refuse_reason == 'undefined') ? '-' : features[0].properties.refuse_reason}</td>
            </tr>
            <tr>
                <td>${t`Начало аренды`}: </td>
                <td class="col_val">${(typeof features[0].properties.rent_started == 'undefined') ? '-' : features[0].properties.rent_started}</td>
            </tr>
            <tr>
                <td>${t`Конец аренды`}: </td>
                <td class="col_val">${(typeof features[0].properties.rent_finish == 'undefined') ? '-' : features[0].properties.rent_finish}</td>
            </tr>
        </table>
    `
);

export const generateDevicesBalanceAtOperationAreasMessage = features => (
    `
        <table class="popup">
            <tr>
                <td>operation_area_id</td>
                <td class="col_val">${features[0].properties.oa_id}</td>
            </tr>
            <tr>
                <td>${t`Абсолютный избыток`}(+) / ${t`дефицит`}(-)</td>
                <td class="col_val">${features[0].properties.deficit_excess_count}</td>
            </tr>
            <tr>
                <td>${t`Абсолютный избыток`}(+) / ${t`дефицит`}(-) ${t`на 1 парковку`}</td>
                <td class="col_val">${Math.round((features[0].properties.deficit_excess_count_by_parking) * 100) / 100}</td>
            </tr>
        </table>
    `
);
export const generateParkingMessage = (features, LngLat) => {
    const lat = LngLat ? LngLat.lat : '';
    const lng = LngLat ? LngLat.lng : '';
    const yandexLink = LngLat
        ? `https://yandex.ru/maps/?l=stv%2Csta&ll=${lng},${lat}&panorama%5Bdirection%5D=91.877107%2C0.000000&panorama%5Bfull%5D=true&panorama%5Bpoint%5D=${lng},${lat}&panorama%5Bspan%5D=119.176452%2C60.000000&z=19`
        : '#';
    const googleLink = LngLat
        ? `https://maps.google.com/maps?q=&layer=c&cbll=${lat},${lng}&cbp=11,90,0,0,0`
        : '#';

    return `
            <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Парковки Whoosh`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>ID</td>
                <td class="col_val">${(typeof features[0].properties.id == 'undefined') ? '-' : features[0].properties.id}</td>
            </tr>
            <tr>
                <td>internal_id</td>
                <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
            </tr>
            <tr>
            <td>${t`Дата создания`}</td>
            <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
            </tr>
            <td>${t`Автор`}</td>
            <td class="col_val">${(typeof features[0].properties.created_by == 'undefined') ? '-' : features[0].properties.created_by}</td>
            </tr>
            <td>${t`Дата редактирования`}</td>
            <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
            </tr>
            <td>${t`Редактор`}</td>
            <td class="col_val">${(typeof features[0].properties.modified_by == 'undefined') ? '-' : features[0].properties.modified_by}</td>
            </tr>
            <tr>
                <td>${t`Адрес`}</td>
                <td class="col_val">${(typeof features[0].properties.address == 'undefined') ? '-' : features[0].properties.address}</td>
            </tr>
            <tr>
                <td>${t`Статус`}</td>
                <td class="col_val">${(typeof features[0].properties.status == 'undefined') ? '-' : features[0].properties.status}</td>
            </tr>
            <tr>
                <td>${t`Вместимость`}</td>
                <td class="col_val">${(typeof features[0].properties.capacity == 'undefined') ? '-' : features[0].properties.capacity}</td>
            </tr>
            <tr>
                <td>${t`Причина деактивации`}</td>
                <td class="col_val">${(typeof features[0].properties.reason == 'undefined') ? '-' : features[0].properties.reason}</td>
            </tr>
            <tr>
                <td>${t`Время деактивации`}</td>
                <td class="col_val">${(typeof features[0].properties.changed_at_reason == 'undefined') ? '-' : features[0].properties.changed_at_reason}</td>
            </tr>
            <tr>
                <td>${t`Координаты`}</td>
                <td class="col_val">${lat.toFixed(6)}, ${lng.toFixed(6)}</td>
            </tr>
            <tr>
            <td class="col_val">
                <a href="${googleLink}" target="_blank"><img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google Icon" style="width: 16px; height: 16px; vertical-align: small; margin-right: 4px;">${t`Panorama`}</a></td>
                <td class="col_val">
                <a href="${yandexLink}" target="_blank"><img src="https://upload.wikimedia.org/wikipedia/commons/5/58/Yandex_icon.svg" alt="Yandex Icon" style="width: 16px; height: 16px; vertical-align: small; margin-right: 4px;">${t`Panorama`}</a>
                </td>
            </tr>
        </table>
    `;
};

export const generateParkingRadiusMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Парковки с радиусом`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Внутренний ID`}</td>
                <td class="col_val">${features[0].properties.internal_id}</td>
            </tr>
            <tr>
                <td>${t`Радиус парковки`} (${t`permitted`})</td>
                <td class="col_val">${features[0].properties.parking_radius}</td>
            </tr>
            <tr>
                <td>${t`Радиус парковки`} (${t`limited`})</td>
                <td class="col_val">${features[0].properties.limited_parking_radius}</td>
            </tr>
            <tr>
                <td>${t`Дата создания`}</td>
                <td class="col_val">${features[0].properties.created_at}</td>
            </tr>
            <tr>
            <td>${t`Дата редактирования`}</td>
            <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
        </tr>
        </table>
    `
);

export const generateAggHexAttentionMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Гексагоны для парковок`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`Hex ID`}</td>
                <td class="col_val">${features[0].properties.hex_id}</td>
            </tr>
            <tr>
                <td>${t`Точек интереса (100м)`}</td>
                <td class="col_val">${features[0].properties.hex_ttl_poi}</td>
            </tr>
            <tr>
                <td>${t`Жилых зданий (400м)`}</td>
                <td class="col_val">${features[0].properties.hex_houses}</td>
            </tr>
            <tr>
                <td>${t`Жителей (400м)`}</td>
                <td class="col_val">${features[0].properties.hex_sum_ppl}</td>
            </tr>
            <tr>
                <td>${t`Тапов (30 дней)`}</td>
                <td class="col_val">${features[0].properties.taps_sum_30d}</td>
            </tr>
            <tr>
                <td>${t`Открытий (30 дней)`}</td>
                <td class="col_val">${features[0].properties.opens_sum_30d}</td>
            </tr>
            <tr>
                <td>${t`Стартов (30 дней)`}</td>
                <td class="col_val">${features[0].properties.starts_sum_30d}</td>
            </tr>
            <tr>
                <td>${t`Индекс`}</td>
                <td class="col_val">${features[0].properties.hex_index_norm}</td>
            </tr>
        </table>
    `
);

export const generateParkingClusterMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Плотность парковок`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>id</td>
                <td class="col_val">${features[0].properties.id}</td>
            </tr>
            <tr>
                <td>${t`Парковок в изохроне 200 метров`}</td>
                <td class="col_val">${features[0].properties.parkings_in_iso_200m}</td>
            </tr>
        </table>
    `
);

export const generateLanduseMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Землепользование`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>natural_bad</td>
                <td class="col_val">${(typeof features[0].properties.natural_bad == 'undefined') ? '-' : features[0].properties.natural_bad}</td>
            </tr>
            <tr>
                <td>amenity</td>
                <td class="col_val">${(typeof features[0].properties.amenity_good == 'undefined') ? '-' : features[0].properties.amenity_good}</td>
            </tr>
            <tr>
                <td>landuse_bad</td>
                <td class="col_val">${(typeof features[0].properties.landuse_bad == 'undefined') ? '-' : features[0].properties.landuse_bad}</td>
            </tr>
            <tr>
                <td>landuse_good</td>
                <td class="col_val">${(typeof features[0].properties.landuse_good == 'undefined') ? '-' : features[0].properties.landuse_good}</td>
            </tr>
        </table>
    `
);

// DA-15980 — попап нового варианта слоя «Землепользование» (источник dwh.urban_zones_classified
// через martin.urban_typology_zones_mvt). Отдельный от generateLanduseMessage: у зон нет
// OSM-тегов natural_bad/landuse_good, вместо них класс типологии и происхождение зоны.
export const generateLanduseZonesMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Землепользование (новый источник)`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>bldg_class</td>
                <td class="col_val">${(typeof features[0].properties.bldg_class == 'undefined') ? '-' : features[0].properties.bldg_class}</td>
            </tr>
            <tr>
                <td>zone_id</td>
                <td class="col_val">${(typeof features[0].properties.zone_id == 'undefined') ? '-' : features[0].properties.zone_id}</td>
            </tr>
            <tr>
                <td>city_id</td>
                <td class="col_val">${(typeof features[0].properties.city_id == 'undefined') ? '-' : features[0].properties.city_id}</td>
            </tr>
            <tr>
                <td>${t`Площадь, га`}</td>
                <td class="col_val">${(typeof features[0].properties.area_m2 == 'undefined') ? '-' : (features[0].properties.area_m2 / 10000).toFixed(2)}</td>
            </tr>
            <tr>
                <td>origin</td>
                <td class="col_val">${(typeof features[0].properties.origin == 'undefined') ? '-' : features[0].properties.origin}</td>
            </tr>
            <tr>
                <td>zone_source</td>
                <td class="col_val">${(typeof features[0].properties.zone_source == 'undefined') ? '-' : features[0].properties.zone_source}</td>
            </tr>
        </table>
    `
);

export const generateScootersDowntimeMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Агрегированный простой самокатов`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>parking_id</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Среднее кол-во самокатов в день`}</td>
                <td class="col_val">${(typeof features[0].properties.scooters_count == 'undefined') ? '-' : features[0].properties.scooters_count}</td>
            </tr>
            <tr>
                <td>${t`Среднее время простоя`}, ${t`ч`}</td>
                <td class="col_val">${(typeof features[0].properties.avg_sb_time == 'undefined') ? '-' : features[0].properties.avg_sb_time}</td>
            </tr>
        </table>
    `
);

// Словарь типов POI (DA-7087): композитный ключ `тег:значение` → читаемая подпись.
// Словарь внутри функции — t`` резолвится в момент вызова с актуальной локалью
// (как в translateCompetitorZoneType). Покрыты основные значения таксономии poi;
// для неизвестных — fallback на сырое значение.
const POI_TYPE_KEYS = [ 'amenity', 'shop', 'tourism', 'leisure', 'office', 'railway', 'highway', 'public_transport' ];
const POI_IGNORED_VALUES = new Set([ 'yes', 'no' ]);
const translatePoiType = props => {
    const labels = {
        // amenity
        'amenity:restaurant': t`Ресторан`,
        'amenity:cafe': t`Кафе`,
        'amenity:fast_food': t`Фастфуд`,
        'amenity:food_court': t`Фудкорт`,
        'amenity:bar': t`Бар`,
        'amenity:pub': t`Паб`,
        'amenity:nightclub': t`Ночной клуб`,
        'amenity:school': t`Школа`,
        'amenity:music_school': t`Музыкальная школа`,
        'amenity:kindergarten': t`Детский сад`,
        'amenity:college': t`Колледж`,
        'amenity:university': t`Университет`,
        'amenity:library': t`Библиотека`,
        'amenity:pharmacy': t`Аптека`,
        'amenity:clinic': t`Клиника`,
        'amenity:hospital': t`Больница`,
        'amenity:doctors': t`Врачебный кабинет`,
        'amenity:dentist': t`Стоматология`,
        'amenity:laboratory': t`Лаборатория`,
        'amenity:atm': t`Банкомат`,
        'amenity:bank': t`Банк`,
        'amenity:fuel': t`АЗС`,
        'amenity:post_office': t`Почта`,
        'amenity:parcel_locker': t`Постамат`,
        'amenity:marketplace': t`Рынок`,
        'amenity:cinema': t`Кинотеатр`,
        'amenity:theatre': t`Театр`,
        'amenity:arts_centre': t`Дом культуры`,
        'amenity:bus_station': t`Автовокзал`,
        'amenity:bicycle_parking': t`Велопарковка`,
        'amenity:bicycle_rental': t`Прокат велосипедов`,
        'amenity:motorcycle_parking': t`Мотопарковка`,
        // shop
        'shop:outpost': t`Пункт выдачи заказов`,
        'shop:convenience': t`Магазин у дома`,
        'shop:supermarket': t`Супермаркет`,
        'shop:general': t`Универсальный магазин`,
        'shop:department_store': t`Универмаг`,
        'shop:mall': t`Торговый центр`,
        'shop:clothes': t`Одежда`,
        'shop:shoes': t`Обувь`,
        'shop:alcohol': t`Алкомаркет`,
        'shop:hardware': t`Хозтовары`,
        'shop:doityourself': t`Стройматериалы`,
        'shop:florist': t`Цветы`,
        'shop:mobile_phone': t`Салон связи`,
        'shop:furniture': t`Мебель`,
        'shop:electronics': t`Электроника`,
        'shop:computer': t`Компьютеры`,
        'shop:pet': t`Зоомагазин`,
        'shop:greengrocer': t`Овощи и фрукты`,
        'shop:stationery': t`Канцтовары`,
        'shop:cosmetics': t`Косметика`,
        'shop:chemist': t`Дрогери`,
        'shop:variety_store': t`Товары для дома`,
        'shop:books': t`Книги`,
        'shop:tobacco': t`Табак`,
        'shop:gift': t`Подарки`,
        'shop:sports': t`Спорттовары`,
        'shop:music': t`Музыкальный магазин`,
        'shop:photo': t`Фотомагазин`,
        'shop:video_games': t`Видеоигры`,
        'shop:bakery': t`Пекарня`,
        'shop:confectionery': t`Кондитерская`,
        // tourism
        'tourism:hotel': t`Отель`,
        'tourism:hostel': t`Хостел`,
        'tourism:motel': t`Мотель`,
        'tourism:guest_house': t`Гостевой дом`,
        'tourism:apartment': t`Апартаменты`,
        'tourism:attraction': t`Достопримечательность`,
        'tourism:museum': t`Музей`,
        'tourism:gallery': t`Галерея`,
        'tourism:theme_park': t`Парк развлечений`,
        'tourism:zoo': t`Зоопарк`,
        'tourism:viewpoint': t`Смотровая площадка`,
        // leisure
        'leisure:sports_centre': t`Спортцентр`,
        'leisure:fitness_centre': t`Фитнес-центр`,
        'leisure:stadium': t`Стадион`,
        'leisure:park': t`Парк`,
        'leisure:dance': t`Танцы`,
        // office
        'office:company': t`Офис компании`,
        'office:telecommunication': t`Телеком`,
        'office:administrative': t`Администрация`,
        'office:government': t`Госучреждение`,
        'office:logistics': t`Логистика`,
        'office:educational_institution': t`Образовательное учреждение`,
        'office:coworking': t`Коворкинг`,
        // railway
        'railway:tram_stop': t`Трамвайная остановка`,
        'railway:subway_entrance': t`Вход в метро`,
        'railway:station': t`Ж/д станция`,
        'railway:platform': t`Платформа`,
        'railway:halt': t`Остановочный пункт`,
        // highway
        'highway:bus_stop': t`Автобусная остановка`,
        // public_transport
        'public_transport:platform': t`Остановочная платформа`,
        'public_transport:station': t`Транспортная станция`,
        'public_transport:stop_area': t`Остановочная зона`,
    };
    for (const key of POI_TYPE_KEYS) {
        const value = props[key];
        if (value && !POI_IGNORED_VALUES.has(value)) {
            return labels[`${key}:${value}`] || value;
        }
    }
    return null;
};

export const generatePoiMessage = features => {
    const props = features[0].properties;
    // Источник фичи: osm | atp (DA-7087). Пустой/неизвестный — считаем OSM.
    const sourceLabel = props.source === 'atp' ? 'AllThePlaces.xyz' : 'OSM';
    // Читаемый построчный формат (DA-7087): тип / «название» / источник.
    const typeLabel = translatePoiType(props);
    const name = props.name;
    const typeLine = typeLabel ? `<div><strong>${typeLabel}</strong></div>` : '';
    const nameLine = name ? `<div>«${name}»</div>` : '';
    const headLine = typeLine || nameLine ? `${typeLine}${nameLine}` : '<div>—</div>';

    return `
        <div class="poi-popup">
            ${headLine}
            <div>${t`Источник данных`}: ${sourceLabel}</div>
        </div>
    `;
};

export const generateBicyclePathMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Велодорожки`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`Название`}</td>
                <td class="col_val">${(typeof features[0].properties.name == 'undefined') ? '-' : features[0].properties.name}</td>
            </tr>
            <tr>
                <td>${t`Тип`}</td>
                <td class="col_val">${features[0].properties.type === 'lane' ? t`Велополоса` : t`Велодорожка`}</td>
            </tr>
            <tr>
                <td>${t`Покрытие`}</td>
                <td class="col_val">${(typeof features[0].properties.surface == 'undefined') ? '-' : features[0].properties.surface}</td>
            </tr>
            <tr>
                <td>${t`Источник данных`}</td>
                <td class="col_val">${(typeof features[0].properties.source == 'undefined') ? 'OSM' : features[0].properties.source}</td>
            </tr>
            <tr>
                <td>${t`Год ввода`}</td>
                <td class="col_val">${(typeof features[0].properties.construction_year == 'undefined') ? '-' : features[0].properties.construction_year}</td>
            </tr>
        </table>
    `
);


// Подписи слоя «Жилые дома». Класс застройки приходит из dwh.buildings_classified кодом
// (residential_multi и т.д.) — человекочитаемые названия держим здесь, а не в базе: витрину
// читают ещё и аналитики напрямую, и SQL-код там удобнее стабильного словаря.
const housesBldgClassLabels = () => ({
    'residential_multi': t`Многоквартирный дом`,
    'residential_individual': t`Индивидуальная застройка`,
    'commercial': t`Коммерческая`,
    'industrial': t`Промышленная`,
    'education': t`Образование`,
    'healthcare': t`Здравоохранение`,
    'campus': t`Кампус`,
    'sport': t`Спорт`,
    'transport_hub': t`Транспортный узел`,
    'service': t`Служебная`,
    'прочее': t`Прочее`,
});
// Пустое поле не показывается вовсе, а не прочерком: в слое почти каждый атрибут
// необязателен — адрес и год есть только по РФ, население не у всякого жилого здания, — и
// попап из одних прочерков сообщал бы читателю ровно ничего. MVT вообще не кладёт в тайл
// свойство со значением NULL, поэтому отсутствующее приходит как undefined.
const housesRow = (label, value) => (
    (typeof value === 'undefined' || value === null || value === '') ? '' : `
            <tr>
                <td>${label}</td>
                <td class="col_val">${value}</td>
            </tr>`
);

export const generateHousesMessage = features => {
    const p = features[0].properties;

    return `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Жилые дома`}
                </strong></td>
            </tr>
        <table class="popup">
            ${housesRow(t`Адрес`, p.address)}
            ${housesRow(t`Год постройки`, p.commission_year)}
            ${housesRow(t`Площадь, м²`, p.total_sq)}
            ${housesRow(t`Этажей`, p.levels)}
            ${housesRow(t`Жителей`, p.total_ppl)}
            ${housesRow(t`Тип застройки`, housesBldgClassLabels()[p.bldg_class] ?? p.bldg_class)}
        </table>
    `;
};

export const generateAnalyticAreasMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Аналитические зоны`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td class="col_val">${(typeof features[0].properties.description == 'undefined') ? '-' : features[0].properties.description}</td>
            </tr>
        </table>
    `
);

export const generateNewBuildingsMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Новостройки`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`Актуальность на дату`}</td>
                <td class="col_val">${(typeof features[0].properties.actual_on_date == 'undefined') ? '-' : features[0].properties.actual_on_date}</td>
            </tr>
            <tr>
                <td>${t`Адрес`}</td>
                <td class="col_val">${(typeof features[0].properties.address == 'undefined') ? '-' : features[0].properties.address}</td>
            </tr>
            <tr>
                <td>${t`Минимальное количество этажей`}</td>
                <td class="col_val">${(typeof features[0].properties.floor_min == 'undefined') ? '-' : features[0].properties.floor_min}</td>
            </tr>
            <tr>
            <tr>
                <td>${t`Максимальное количество этажей`}</td>
                <td class="col_val">${(typeof features[0].properties.floor_max == 'undefined') ? '-' : features[0].properties.floor_max}</td>
            </tr>
            <tr>
                <td>${t`Количество квартир, шт`}</td>
                <td class="col_val">${(typeof features[0].properties.flat_cnt == 'undefined') ? '-' : features[0].properties.flat_cnt}</td>
            </tr>
            <tr>
                <td>${t`Общая жилая площадь, кв.м`}</td>
                <td class="col_val">${(typeof features[0].properties.flat_sqr == 'undefined') ? '-' : features[0].properties.flat_sqr}</td>
            </tr>
            <tr>
                <td>${t`Класс жилья`}</td>
                <td class="col_val">${(typeof features[0].properties.object_class == 'undefined') ? '-' : features[0].properties.object_class}</td>
            </tr>
            <tr>
            <td>${t`Средняя цена за 1 кв.м`}</td>
            <td class="col_val">${(typeof features[0].properties.price_avg == 'undefined') ? '-' : features[0].properties.price_avg}</td>
             </tr>           
            <tr>
                <td>${t`Продано квартир на текущий момент`}</td>
                <td class="col_val">${(typeof features[0].properties.apartment_realised == 'undefined') ? '-' : features[0].properties.apartment_realised}</td>
            </tr>
            <tr>
                <td>${t`Кол-во жильцов`}</td>
                <td class="col_val">${(typeof features[0].properties.max_ppl == 'undefined') ? '-' : features[0].properties.max_ppl}</td>
            </tr>
            <tr>
            <td>${t`Дата выдачи ключей`}</td>
            <td class="col_val">${(typeof features[0].properties.date_keys == 'undefined') ? '-' : features[0].properties.date_keys}</td>
            </tr>
            <tr>
            <td>${t`Год сдачи объекта`}</td>
            <td class="col_val">${(typeof features[0].properties.ready_year == 'undefined') ? '-' : features[0].properties.ready_year}</td>
        </tr>
        </table>
    `
);

export const generateEnclosuresMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Кварталы`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
            <td>${t`ID квартала`}</td>
            <td class="col_val">${(typeof features[0].properties.id == 'undefined') ? '-' : features[0].properties.id}</td>
            <tr>
                <td>${t`Площадь, кв.м`}</td>
                <td class="col_val">${(typeof features[0].properties.area_sqkm == 'undefined') ? '-' : features[0].properties.area_sqkm}</td>
            </tr>
            <tr>
                <td>${t`Численность населения`}</td>
                <td class="col_val">${(typeof features[0].properties.total_ppl == 'undefined') ? '-' : features[0].properties.houses_n}</td>
            </tr>
            <tr>
                <td>${t`Количество POI`}</td>
                <td class="col_val">${(typeof features[0].properties.poi_n == 'undefined') ? '-' : features[0].properties.poi_n}</td>
            </tr>
            <tr>
            <td>${t`Доля жителей`}</td>
            <td class="col_val">${(typeof features[0].properties.ppl_city_share == 'undefined') ? '-' : features[0].properties.ppl_city_share}</td>
             </tr>           
            <tr>
            <td>${t`Доля POI`}</td>
            <td class="col_val">${(typeof features[0].properties.poi_city_share == 'undefined') ? '-' : features[0].properties.poi_city_share}</td>
            </tr>
            <td>${t`Плотность жителей`}</td>
            <td class="col_val">${(typeof features[0].properties.ppl_density == 'undefined') ? '-' : features[0].properties.ppl_density}</td>
             </tr>           
            <tr>
            <td>${t`Плотность POI`}</td>
            <td class="col_val">${(typeof features[0].properties.poi_density == 'undefined') ? '-' : features[0].properties.poi_density}</td>
            </tr>
            </tr>
            <td><big><strong>${t`Самокатов`}</strong></big></td>
            <td class="col_val"><big><strong>${features[0].properties.scooter_final_flexible}</strong></big></td>
            </tr> 
        </table>
    `
);

export const generateClassifiedParkingsMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Классифицированные парковки`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Внутренний ID`}</td>
                <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
            </tr>
            <tr>
                <td>${t`Статус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.status == 'undefined') ? '-' : features[0].properties.status}</td>
            </tr>
            <tr>
                <td>${t`Дата создания`}</td>
                <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
            </tr>
            <tr>
                <td>${t`Дата изменения`}</td>
                <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
            </tr>
            <tr>
                <td>${t`Радиус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_radius == 'undefined') ? '-' : features[0].properties.parking_radius}</td>
            </tr>
            <tr>
                <td>${t`Класс парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.class_ == 'undefined') ? '-' : features[0].properties.class_}</td>
            </tr>
            <tr>
                <td>${t`Тип парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.type_ == 'undefined') ? '-' : features[0].properties.type_}</td>
            </tr>
            <tr>
                <td>${t`Стартов`}</td>
                <td class="col_val">${(typeof features[0].properties.count_from == 'undefined') ? '-' : features[0].properties.count_from}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем стартов в день`}</strong></td>
                <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_from_per_day == 'undefined') ? '-' : features[0].properties.avg_from_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Финишей`}</td>
                <td class="col_val">${(typeof features[0].properties.count_to == 'undefined') ? '-' : features[0].properties.count_to}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем финишей в день`}</strong></td>
                <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_to_per_day == 'undefined') ? '-' : features[0].properties.avg_to_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Стартов больше финишей`}, % </td>
                <td class="col_val">${(typeof features[0].properties.starts_more_finishes == 'undefined') ? '-' : features[0].properties.starts_more_finishes}</td>
            </tr>
        </table>
    `
);

export const generateClassifiedParkingsDayPartMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Классифицированные парковки (по времени суток)`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Внутренний ID`}</td>
                <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
            </tr>
            <tr>
                <td>${t`Статус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.status == 'undefined') ? '-' : features[0].properties.status}</td>
            </tr>
            <tr>
                <td>${t`Дата создания`}</td>
                <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
            </tr>
            <tr>
                <td>${t`Дата изменения`}</td>
                <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
            </tr>
            <tr>
                <td>${t`Радиус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_radius == 'undefined') ? '-' : features[0].properties.parking_radius}</td>
            </tr>
            <tr>
                <td>${t`Класс парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.class_ == 'undefined') ? '-' : features[0].properties.class_}</td>
            </tr>
            <tr>
                <td>${t`Тип парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.type_ == 'undefined') ? '-' : features[0].properties.type_}</td>
            </tr>
            <tr>
                <td>${t`Стартов`}</td>
                <td class="col_val">${(typeof features[0].properties.count_from == 'undefined') ? '-' : features[0].properties.count_from}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем стартов в день`}</strong></td>
                <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_from_per_day == 'undefined') ? '-' : features[0].properties.avg_from_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Финишей`}</td>
                <td class="col_val">${(typeof features[0].properties.count_to == 'undefined') ? '-' : features[0].properties.count_to}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем финишей в день`}</strong></td>
                <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_to_per_day == 'undefined') ? '-' : features[0].properties.avg_to_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Стартов больше финишей`}, % </td>
                <td class="col_val">${(typeof features[0].properties.starts_more_finishes == 'undefined') ? '-' : features[0].properties.starts_more_finishes}</td>
            </tr>
        </table>
    `
);

export const generateParkingsAlertsPointsZoomHintMessage = () => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Алерты завершения парковки`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td class="col_val">${t`Приблизьте карту, чтобы узнать детали`}</td>
            </tr>
        </table>
    `
);

export const generateParkingsAlertsPointsMessage = features => {
    const parkingChoice = features[0].properties.parking_choice;
    // Для Device-ошибок скрываем «телефонные» строки, для Phone-ошибок — «девайсные»
    const isPhone = parkingChoice === 'PHONE';
    const isDevice = parkingChoice === 'DEVICE';
    const deviceRows = `
            <tr>
                <td><strong style="font-size: 0.8em;">${t`Метров до парковки от девайса`}</strong></td>
                <td class="col_val">${(typeof features[0].properties.device_distance == 'undefined') ? '-' : features[0].properties.device_distance}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 0.8em;">${t`ID парковки (девайс)`}</strong></td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>`;
    const phoneRows = `
            <tr>
                <td><strong style="font-size: 0.8em;">${t`Метров до парковки от телефона`}</strong></td>
                <td class="col_val">${(typeof features[0].properties.phone_parking_distance == 'undefined') ? '-' : features[0].properties.phone_parking_distance}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 0.8em;">${t`ID парковки (телефон)`}</strong></td>
                <td class="col_val">${(typeof features[0].properties.phone_parking_id == 'undefined') ? '-' : features[0].properties.phone_parking_id}</td>
            </tr>`;
    // Релевантный id парковки: для Phone-ошибки — телефонный, иначе — девайсный
    const relevantParkingId = isPhone
        ? features[0].properties.phone_parking_id
        : features[0].properties.parking_id;
    const highlightButtonRow = (relevantParkingId === null || typeof relevantParkingId === 'undefined' || relevantParkingId === -1)
        ? ''
        : `
            <tr>
                <td colspan="2" style="padding-top: 6px;">
                    <button type="button" class="highlight-parking-alerts-btn" data-parking-id="${relevantParkingId}">
                        ${t`Подсветить алерты этой парковки`}
                    </button>
                </td>
            </tr>`;

    return `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Алерты завершения парковки`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`Создано`}</td>
                <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
            </tr>
            <tr>
                <td>${t`Номер попытки`}</td>
                <td class="col_val">${(typeof features[0].properties.n_attemp == 'undefined') ? '-' : features[0].properties.n_attemp}</td>
            </tr>
            <tr>
                <td>${t`ID поездки`}</td>
                <td class="col_val">${(typeof features[0].properties.trip_id == 'undefined') ? '-' : features[0].properties.trip_id}</td>
            </tr>
            <tr>
                <td>${t`Регион`}</td>
                <td class="col_val">${(typeof features[0].properties.region_name == 'undefined') ? '-' : features[0].properties.region_name}</td>
            </tr>
            <tr>
                <td>${t`Устройство`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_choice == 'undefined') ? '-' : features[0].properties.parking_choice}</td>
            </tr>
            <tr>
                <td>${t`Тип ошибки`}</td>
                <td class="col_val">${(typeof features[0].properties.device_phone_state == 'undefined') ? '-' : features[0].properties.device_phone_state}</td>
            </tr>
            ${isPhone ? '' : deviceRows}
            ${isDevice ? '' : phoneRows}
            ${highlightButtonRow}
        </table>
    `;
};

export const generateClassifiedParkingsRebalancedMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Классифицированные парковки (ребаланс)`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Внутренний ID`}</td>
                <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
            </tr>
            <tr>
                <td>${t`Статус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.status == 'undefined') ? '-' : features[0].properties.status}</td>
            </tr>
            <tr>
                <td>${t`Дата создания`}</td>
                <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
            </tr>
            <tr>
                <td>${t`Дата изменения`}</td>
                <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
            </tr>
            <tr>
                <td>${t`Радиус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_radius == 'undefined') ? '-' : features[0].properties.parking_radius}</td>
            </tr>
            <tr>
                <td>${t`Класс парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.class_ == 'undefined') ? '-' : features[0].properties.class_}</td>
            </tr>
            <tr>
                <td>${t`Тип парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.type_ == 'undefined') ? '-' : features[0].properties.type_}</td>
            </tr>
            <tr>
                <td>${t`Ребаланса с парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.count_from == 'undefined') ? '-' : features[0].properties.count_from}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем ребаланса с парковки в день`}</strong></td>
                <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_from_per_day == 'undefined') ? '-' : features[0].properties.avg_from_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Ребаланса на парковку`}</td>
                <td class="col_val">${(typeof features[0].properties.count_to == 'undefined') ? '-' : features[0].properties.count_to}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем ребаланса на парковку в день`}</strong></td>
                <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_to_per_day == 'undefined') ? '-' : features[0].properties.avg_to_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Ребаланса на парковку больше`}, % </td>
                <td class="col_val">${(typeof features[0].properties.starts_more_finishes == 'undefined') ? '-' : features[0].properties.starts_more_finishes}</td>
            </tr>
        </table>
    `
);

export const generateClassifiedParkingsDayPartRebalancedMessage = features => (
    `
    <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Классифицированные парковки (ребаланс, по времени суток)`}
                </strong></td>
            </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Внутренний ID`}</td>
                <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
            </tr>
            <tr>
                <td>${t`Статус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.status == 'undefined') ? '-' : features[0].properties.status}</td>
            </tr>
            <tr>
                <td>${t`Дата создания`}</td>
                <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
            </tr>
            <tr>
                <td>${t`Дата изменения`}</td>
                <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
            </tr>
            <tr>
                <td>${t`Радиус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_radius == 'undefined') ? '-' : features[0].properties.parking_radius}</td>
            </tr>
            <tr>
                <td>${t`Класс парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.class_ == 'undefined') ? '-' : features[0].properties.class_}</td>
            </tr>
            <tr>
                <td>${t`Тип парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.type_ == 'undefined') ? '-' : features[0].properties.type_}</td>
            </tr>
            <tr>
                <td>${t`Ребаланса с парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.count_from == 'undefined') ? '-' : features[0].properties.count_from}</td>
            </tr>
            <tr>
                <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем ребаланса с парковки в день`}</strong></td>
                <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_from_per_day == 'undefined') ? '-' : features[0].properties.avg_from_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Ребаланса на парковку`}</td>
                <td class="col_val">${(typeof features[0].properties.count_to == 'undefined') ? '-' : features[0].properties.count_to}</td>
            </tr>
            <tr>
            <td><strong style="font-size: 1.2em; text-decoration: underline;">${t`В среднем ребаланса на парковку в день`}</strong></td>
            <td class="col_val"><strong style="font-size: 1.2em; text-decoration: underline;">${(typeof features[0].properties.avg_to_per_day == 'undefined') ? '-' : features[0].properties.avg_to_per_day}</strong></td>
            </tr>
            <tr>
                <td>${t`Ребаланса на парковку больше`}, % </td>
                <td class="col_val">${(typeof features[0].properties.starts_more_finishes == 'undefined') ? '-' : features[0].properties.starts_more_finishes}</td>
            </tr>
        </table>
    `
);

// Popup message for "Агрегированные треки за последние 7 дней" layer (H3 zoom 6-12)
export const trackHexCountV2 = features => {
    const p = features[0].properties;
    return `
    <div class="popup-content">
        <table cellspacing="7px" class="mapboxgl-popup-content-table">
            <thead>
                <tr>
                    <th colspan="4" class="col_val" style="font-size: 1em; font-weight: bold;">
                        ${t`Агрегированные треки за последние 7 дней`} (H3 zoom: ${p.zoom})
                    </th>
                </tr>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="col">${t``}</th>
                    <th scope="col">${t`Неделя`}</th>
                    <th scope="col">${t`Будни`}</th>
                    <th scope="col">${t`Выходные`}</th>
                </tr>
            </thead>
            <tbody>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="row">${t`Всего`}</th>
                    <td class="col_val">${p.count_all}</td>
                    <td class="col_val">${p.count_all_weekdays}</td>
                    <td class="col_val">${p.count_all_weekends}</td>
                </tr>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="row">${t`Самокаты`}</th>
                    <td class="col_val">${p.count_scooters}</td>
                    <td class="col_val">${p.count_scooters_weekdays}</td>
                    <td class="col_val">${p.count_scooters_weekends}</td>
                </tr>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="row">${t`Велосипеды`}</th>
                    <td class="col_val">${p.count_bikes}</td>
                    <td class="col_val">${p.count_bikes_weekdays}</td>
                    <td class="col_val">${p.count_bikes_weekends}</td>
                </tr>
            </tbody>
        </table>
    </div>
    `;
};

// Popup message for "Агрегированные треки за месяц" layer (H3 zoom 6-12, DA-14786)
export const trackHexCountMonthly = (features, month) => {
    const p = features[0].properties;
    return `
    <div class="popup-content">
        <table cellspacing="7px" class="mapboxgl-popup-content-table">
            <thead>
                <tr>
                    <th colspan="4" class="col_val" style="font-size: 1em; font-weight: bold;">
                        ${t`Агрегированные треки за месяц`}${month ? ` ${month}` : ''} (H3 zoom: ${p.zoom})
                    </th>
                </tr>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="col">${t``}</th>
                    <th scope="col">${t`Месяц`}</th>
                    <th scope="col">${t`Будни`}</th>
                    <th scope="col">${t`Выходные`}</th>
                </tr>
            </thead>
            <tbody>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="row">${t`Всего`}</th>
                    <td class="col_val">${p.count_all}</td>
                    <td class="col_val">${p.count_all_weekdays}</td>
                    <td class="col_val">${p.count_all_weekends}</td>
                </tr>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="row">${t`Самокаты`}</th>
                    <td class="col_val">${p.count_scooters}</td>
                    <td class="col_val">${p.count_scooters_weekdays}</td>
                    <td class="col_val">${p.count_scooters_weekends}</td>
                </tr>
                <tr class="mapboxgl-popup-content-row">
                    <th scope="row">${t`Велосипеды`}</th>
                    <td class="col_val">${p.count_bikes}</td>
                    <td class="col_val">${p.count_bikes_weekdays}</td>
                    <td class="col_val">${p.count_bikes_weekends}</td>
                </tr>
            </tbody>
        </table>
    </div>
    `;
};

// Popup message for "Агрегированные поездки (август)" layer
export const trackTripsCountAugustH3 = features => {
    const properties = features[0].properties;
    const yearLabels = [ 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026 ];
    const tripsValues = [
        properties.trips_2019,
        properties.trips_2020,
        properties.trips_2021,
        properties.trips_2022,
        properties.trips_2023,
        properties.trips_2024,
        properties.trips_2025,
        properties.trips_2026,
    ];
    // Function to calculate percentage difference from the previous year
    const calcPercentageDifference = (current, previous) => {
        if (previous === 0) return 0; // Avoid division by zero
        const diff = ((current - previous) / previous) * 100;
        if (isNaN(diff) || !isFinite(diff)) return 0; // Return 0 if NaN or Infinity
        return `${Math.round(diff)}%`; // Return percentage rounded to whole numbers
    };
    // Calculate the percentage differences between the years
    const percentageDifferences = tripsValues.map((value, index) => {
        if (index === 0) return 0; // No previous year for 2019
        return calcPercentageDifference(value, tripsValues[index - 1]);
    });
    // Define the row data for your table
    const rows = [
        {
            name: t`Количество поездок`,
            values: tripsValues,
        },
        {
            name: t`Разница к пред. году в %`,
            values: percentageDifferences,
        },
    ];
    // Check if all values for this row are zero
    const allZero = arr => arr.every(value => Number(value) === 0 || value === 'N/A');
    // Filter out rows where all values are zero
    const nonZeroRows = rows.filter(row => !allZero(row.values));
    // Create the table rows dynamically
    const tableRows = nonZeroRows.map(row => (
        `<tr class="mapboxgl-popup-content-row">
            <th scope="row">${row.name}</th>
            ${row.values.map(value => `<td class="col_val">${value}</td>`).join('')}
        </tr>`
    )).join('');

    // Return the full HTML structure for the popup content
    return `
<tr>
     <td></td>
     <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
     ${t`Агрегированные поездки (август)`} zoom = ${properties.zoom || 'N/A'}
     </strong></td>
 </tr>
    <div class="popup-content">
      <table cellspacing="7px">
        <thead>
          <tr>
            <th scope="col">${t`Год`}</th>
            ${yearLabels.map(year => `<th scope="col">${year}</th>`).join('')}
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
      </table>
    </div>
    `;
};

// Отключён тестовый слой "Агрегированные треки (август) test"
// export const h3TripsAugustMessage = features => {
//     const properties = features[0].properties;
//     return `
// <tr>
//      <td></td>
//      <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
//      ${t`Агрегированные треки (август) test`}
//      </strong></td>
//  </tr>
//     <div class="popup-content">
//       <table class="popup">
//         <tr>
//             <td>${t`H3 индекс`}</td>
//             <td class="col_val">${properties.h3}</td>
//         </tr>
//         <tr>
//             <td>${t`Зум`}</td>
//             <td class="col_val">${properties.zoom}</td>
//         </tr>
//         <tr>
//             <td>${t`Количество поездок`}</td>
//             <td class="col_val">${properties.sum_tracks_2025}</td>
//         </tr>
//       </table>
//     </div>
//     `;
// };

export const rechargingStatsMessage = (features, period = 'seasons') => {
    const properties = features[0].properties;
    // DA-14276: выбираем колонку и метку периода
    const periodLabels = {
        'seasons': t`Сезоны 2024–2025 гг.`,
        '1d':      t`1 день`,
        '7d':      t`7 дней`,
        '30d':     t`30 дней`,
    };
    const colMap = {
        'seasons': 'cnt_recharges_seasons',
        '1d':      'cnt_recharges_1d',
        '7d':      'cnt_recharges_7d',
        '30d':     'cnt_recharges_30d',
    };
    const col = colMap[period] ?? 'cnt_recharges_seasons';
    const periodLabel = periodLabels[period] ?? period;
    const rawVal = properties[col];
    const value = rawVal !== null ? Math.round(rawVal ?? 0) : '—';

    return `
<tr>
     <td></td>
     <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
     ${t`Кол-во переходов в Change Battery`}
     </strong></td>
 </tr>
    <div class="popup-content">
      <table class="popup">
        <tr>
            <td>${t`Период`}</td>
            <td class="col_val">${periodLabel}</td>
        </tr>
        <tr>
            <td>${t`Индекс h3`}</td>
            <td class="col_val">${properties.h3}</td>
        </tr>
        <tr>
            <td>${t`Зум`}</td>
            <td class="col_val">${properties.zoom}</td>
        </tr>
        <tr>
            <td>${t`Количество переходов`}</td>
            <td class="col_val">${value}</td>
        </tr>
      </table>
    </div>
    `;
};

// DA-12966: потерянные самокаты (LOST / DELETED)
export const generateLostClusterMessage = features => {
    const props = features[0]?.properties ?? {};
    const countLost    = props.count_lost    ?? 0;
    const countDeleted = props.count_deleted ?? 0;
    const total        = props.total_count   ?? (countLost + countDeleted);
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Кластер потерянных самокатов`}
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <th></th>
            <th class="col_val" style="color:#eab308; text-align:right;">LOST</th>
            <th class="col_val" style="color:#ef4444; text-align:right;">DELETED</th>
        </tr>
        <tr>
            <td>${t`Всего`}</td>
            <td class="col_val" style="text-align:right;"><strong>${countLost}</strong></td>
            <td class="col_val" style="text-align:right;"><strong>${countDeleted}</strong></td>
        </tr>
        <tr>
            <td>${t`Итого в кластере`}</td>
            <td class="col_val" colspan="2" style="text-align:right;"><strong>${total}</strong></td>
        </tr>
    </table>
    `;
};

// Вероятные призраки: попап общий для точек «показан», «вероятно здесь» и линии между ними
export const generateGhostDevicesMessage = features => {
    const props = features[0]?.properties ?? {};
    const status = props.status ?? '-';
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Вероятный призрак`}
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`Номер самоката`}</td>
            <td class="col_val"><strong>${props.code ?? '-'}</strong></td>
        </tr>
        <tr>
            <td>${t`Статус`}</td>
            <td class="col_val">${status}</td>
        </tr>
        <tr>
            <td>${t`Показан от финиша`}</td>
            <td class="col_val">${props.drift_m ?? '-'} ${t`м`}</td>
        </tr>
        <tr>
            <td>${t`Стоит с`}</td>
            <td class="col_val">${props.entered_at_local ?? '-'} (${props.idle_h ?? '-'} ${t`ч`})</td>
        </tr>
        <tr>
            <td>${t`Самокат и телефон на финише`}</td>
            <td class="col_val">${props.finish_agree_m ?? '-'} ${t`м`}</td>
        </tr>
        <tr>
            <td>${t`Источник позиции`}</td>
            <td class="col_val">${props.signal_source ?? '-'}${props.accuracy ? ` (± ${props.accuracy} ${t`м`})` : ''}</td>
        </tr>
        <tr>
            <td>${t`Поколение IoT`}</td>
            <td class="col_val">${props.gen ?? '-'}</td>
        </tr>
    </table>
    <div style="margin-top: 6px; max-width: 260px;">${t`Скорее всего стоит на финише последней поездки — зелёная точка.`}</div>
    `;
};

// DEV → Поиск лостов: попап на точке хвоста, якоре и финише.
// Источники: dsul — смена статуса, scan — скан клиента, resv — бронь, ble — BLE-скан телефона,
// lbs — собственный GNSS-фикс самоката. Радиус у ble измеренный, у остальных — типичная
// ошибка источника (68-й перцентиль расхождения с телефоном, стоящим у самоката).
const LOST_SEARCH_SRC_LABELS = {
    dsul: t`смена статуса`,
    scan: t`скан клиента`,
    resv: t`бронь`,
    ble: t`BLE-скан телефона`,
    lbs: t`GNSS самоката`,
    finish: t`конец поездки`,
    // сырой IoT-хартбит: src приходит как есть из type=track
    GPS: t`GNSS самоката`,
    PHONE_GPS: t`GPS телефона`,
    LBS: t`вышки GSM`,
    GSM: t`сота GSM`,
    BLE_S: t`BLE-скан`,
    WCMA_GPS: t`GPS сотрудника`,
    WCMA_MANUAL: t`отметка вручную`,
    UNKN: t`источник неизвестен`,
};
const LOST_SEARCH_CLS_LABELS = {
    A: t`умер на финише`,
    B: t`выбросы координат`,
    C: t`сместился < 1 км`,
    D1: t`разрядился на финише`,
    D2: t`пропал с зарядом`,
    E: t`уехал > 1 км`,
};
// в тайле числа приходят строками, а пустое значение — отсутствующим ключом
const lostSearchPercent = value => (value === '' || value === null || Number.isNaN(Number(value))
    ? '-'
    : `${value}%`);
export const generateLostSearchMessage = features => {
    const props = features[0]?.properties ?? {};
    const kind = props.kind;
    const title = {
        anchor: t`Где искать`,
        finish: t`Финиш последней поездки`,
    }[kind] ?? t`Сигнал перед отключением`;
    const src = LOST_SEARCH_SRC_LABELS[props.src] ?? props.src ?? '-';
    const isPoint = kind === 'point';
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${title}
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`Номер самоката`}</td>
            <td class="col_val"><strong>${props.code ?? '-'}</strong></td>
        </tr>
        <tr>
            <td>${t`Как замолчал`}</td>
            <td class="col_val">${LOST_SEARCH_CLS_LABELS[props.cls] ?? props.cls ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`Время сигнала`}</td>
            <td class="col_val">${props.ts_local ?? '-'}</td>
        </tr>
        ${isPoint ? `
        <tr>
            <td>${t`Источник`}</td>
            <td class="col_val">${src}</td>
        </tr>
        <tr>
            <td>${t`Радиус`}</td>
            <td class="col_val">${props.radius_m ? `± ${props.radius_m} ${t`м`}` : '-'}</td>
        </tr>
        <tr>
            <td>${t`Заряд`}</td>
            <td class="col_val">${lostSearchPercent(props.batt)}</td>
        </tr>` : ''}
        <tr>
            <td>${t`Ушёл в LOST`}</td>
            <td class="col_val">${props.lost_at_local ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`Заряд на последнем сигнале`}</td>
            <td class="col_val">${lostSearchPercent(props.last_batt)}</td>
        </tr>
        <tr>
            <td>${t`Сигналов после финиша`}</td>
            <td class="col_val">${props.n_pts ?? '-'}</td>
        </tr>
    </table>
    ${props.is_weak === true || props.is_weak === 'true'
        ? `<div style="margin-top: 6px; max-width: 260px;">${t`Точка улетела от якоря дальше километра — скорее всего кривой GNSS-фикс, идти сюда не надо.`}</div>`
        : ''}
    ${props.is_theft_suspect === true || props.is_theft_suspect === 'true'
            ? `<div style="margin-top: 6px; max-width: 260px;">${t`Самокат замолчал с живой батареей — не разрядился, а был выключен или экранирован.`}</div>`
            : ''}
    `;
};

// Источник позиции в слое «Потерянные самокаты» (martin.lost_devices.position_source)
const LOST_DEVICES_POSITION_SRC_LABELS = {
    DEVICE: t`GNSS самоката`,
    PHONE: t`телефон клиента`,
    STATUS_CHANGE: t`точка смены статуса`,
    UNKNOWN: t`источник неизвестен`,
};

export const generateLostDevicesMessage = features => {
    const props = features[0]?.properties ?? {};
    const positionSrc = LOST_DEVICES_POSITION_SRC_LABELS[props.position_source] ?? props.position_source ?? '-';
    const statusLabel = props.combined_status === 'LOST'
        ? t`LOST (потерян)`
        : props.combined_status === 'DELETED'
            ? t`DELETED (утерян безвозвратно)`
            : props.combined_status ?? '-';
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Потерянный самокат`}
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`Номер самоката`}</td>
            <td class="col_val"><strong>${props.code ?? '-'}</strong></td>
        </tr>
        <tr>
            <td>${t`Статус`}</td>
            <td class="col_val">${statusLabel}</td>
        </tr>
        <tr>
            <td>${t`Предыдущий статус`}</td>
            <td class="col_val">${props.previous_status ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`Дата изменения статуса`}</td>
            <td class="col_val">${props.modified_at ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`Время позиции (UTC)`}</td>
            <td class="col_val">${props.position_at ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`Источник позиции`}</td>
            <td class="col_val">${positionSrc}</td>
        </tr>
    </table>
    `;
};

export const aggHexRentMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Сглаженные показатели аренды`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
            <td>${t`Количество объявлений`}</td>
            <td class="col_val">${(typeof features[0].properties.n_ads == 'undefined') ? '-' : features[0].properties.n_ads}</td>
        </tr>
        <tr>
            <td>${t`Минимальная цена`}</td>
            <td class="col_val">${(typeof features[0].properties.min_price == 'undefined') ? '-' : features[0].properties.min_price}</td>
        </tr>
        <tr>
            <td>${t`Средняя цена`}</td>
            <td class="col_val">${(typeof features[0].properties.avg_price == 'undefined') ? '-' : features[0].properties.avg_price}</td>
        </tr>
        <tr>
            <td>${t`Максимальная цена`}</td>
            <td class="col_val">${(typeof features[0].properties.max_price == 'undefined') ? '-' : features[0].properties.max_price}</td>
        </tr>
        <tr>
            <td>${t`Средняя цена за кв.м`}</td>
            <td class="col_val">${(typeof features[0].properties.avg_price_per_sqm == 'undefined') ? '-' : features[0].properties.avg_price_per_sqm}</td>
        </tr>
        </table>
    `
);
export const functionalAreasMessage = features => {
    const props = features[0].properties;
    const getVal = key => (typeof props[key] === 'undefined' ? '-' : props[key]);
    const isFictitiousValue = typeof props.is_fictitious === 'undefined'
        ? '-'
        : props.is_fictitious === 1
            ? t`Да`
            : props.is_fictitious === 0
                ? t`Нет`
                : props.is_fictitious;

    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Функциональные зоны`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`ID зоны`}</td>
                <td class="col_val">${getVal('id')}</td>
            </tr>
            <tr>
                <td>${t`Тип зоны`}</td>
                <td class="col_val">${getVal('type')}</td>
            </tr>
            <tr>
                <td>${t`Фиктивная`}</td>
                <td class="col_val">${isFictitiousValue}</td>
            </tr>
            <tr>
                <td>${t`Дата создания`}</td>
                <td class="col_val">${getVal('created_at')}</td>
            </tr>
            <tr>
                <td>${t`Автор`}</td>
                <td class="col_val">${getVal('created_by')}</td>
            </tr>
            <tr>
                <td>${t`Дата редактирования`}</td>
                <td class="col_val">${getVal('modified_at')}</td>
            </tr>
            <tr>
                <td>${t`Редактор`}</td>
                <td class="col_val">${getVal('modified_by')}</td>
            </tr>
        </table>
    `;
};

export const cityBoundariesMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Границы города`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
        <td>${t`ID`}</td>
        <td class="col_val">${(typeof features[0].properties.id == 'undefined') ? '-' : features[0].properties.id}</td>
        </tr>
        <tr>
        <td>${t`ID Региона`}</td>
        <td class="col_val">${(typeof features[0].properties.region_id == 'undefined') ? '-' : features[0].properties.region_id}</td>
        </tr>
        <tr>
        <td>${t`Название города`}</td>
        <td class="col_val">${(typeof features[0].properties.city == 'undefined') ? '-' : features[0].properties.city}</td>
        </tr>
        </table>
    `
);
export const operationalAreasMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Операционные зоны`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
        <td>${t`Название зоны`}</td>
        <td class="col_val">${(typeof features[0].properties.name == 'undefined') ? '-' : features[0].properties.name}</td>
        </tr>
        <tr>
        <td>${t`ID`}</td>
        <td class="col_val">${(typeof features[0].properties.id == 'undefined') ? '-' : features[0].properties.id}</td>
        </tr>
        <tr>
        <td>${t`Внутренний ID`}</td>
        <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
        </tr>
        <tr>
        <td>${t`Номер зоны`}</td>
        <td class="col_val">${(typeof features[0].properties.number == 'undefined') ? '-' : features[0].properties.number}</td>
        </tr>
        <tr>
            <td>${t`Дата создания`}</td>
            <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
        </tr>
        <tr>
            <td>${t`Автор`}</td>
            <td class="col_val">${(typeof features[0].properties.created_by == 'undefined') ? '-' : features[0].properties.created_by}</td>
        </tr>
        <tr>
            <td>${t`Дата редактирования`}</td>
            <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
        </tr>
        <tr>
            <td>${t`Редактор`}</td>
            <td class="col_val">${(typeof features[0].properties.modified_by == 'undefined') ? '-' : features[0].properties.modified_by}</td>
        </tr>
        </table>
    `
);
export const operationalAreasLabelsMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Операционные зоны`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
            <td>${t`ID`}</td>
            <td class="col_val">${(typeof features[0].properties.id == 'undefined') ? '-' : features[0].properties.id}</td>
        </tr>
        <tr>
        <tr>
            <td>${t`Внутренний ID`}</td>
            <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
        </tr>
        <tr>
        <td>${t`Название зоны`}</td>
        <td class="col_val">${(typeof features[0].properties.name == 'undefined') ? '-' : features[0].properties.name}</td>
        </tr>
        <tr>
            <td>${t`Дата создания`}</td>
            <td class="col_val">${(typeof features[0].properties.created_at == 'undefined') ? '-' : features[0].properties.created_at}</td>
        </tr>
        <tr>
            <td>${t`Автор`}</td>
            <td class="col_val">${(typeof features[0].properties.created_by == 'undefined') ? '-' : features[0].properties.created_by}</td>
        </tr>
        <tr>
            <td>${t`Дата редактирования`}</td>
            <td class="col_val">${(typeof features[0].properties.modified_at == 'undefined') ? '-' : features[0].properties.modified_at}</td>
        </tr>
        <tr>
            <td>${t`Редактор`}</td>
            <td class="col_val">${(typeof features[0].properties.modified_by == 'undefined') ? '-' : features[0].properties.modified_by}</td>
        </tr>
        </table>
    `
);
export const dynamicTariffZonesMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Особые зоны динамического тарифа`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
            <td>${t`ID`}</td>
            <td class="col_val">${(typeof features[0].properties.id == 'undefined') ? '-' : features[0].properties.id}</td>
        </tr>
        <tr>
        <td>${t`Код зоны`}</td>
        <td class="col_val">${(typeof features[0].properties.zone_code == 'undefined') ? '-' : features[0].properties.zone_code}</td>
        </tr>
        <tr>
            <td>${t`Описание`}</td>
            <td class="col_val">${(typeof features[0].properties.info_ == 'undefined') ? '-' : features[0].properties.info_}</td>
        </tr>
        <tr>
            <td>${t`Тип`}</td>
            <td class="col_val">${(typeof features[0].properties.type_ == 'undefined') ? '-' : features[0].properties.type_}</td>
        </tr>
        </table>
    `
);
export const dynamicTariffScoreMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Динамический тариф`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
            <td>${t`HEX ID`}</td>
            <td class="col_val">${(typeof features[0].properties.hex_id == 'undefined') ? '-' : features[0].properties.hex_id}</td>
        </tr>
        <tr>
        <td>${t`Score`}</td>
        <td class="col_val">${(typeof features[0].properties.score == 'undefined') ? '-' : features[0].properties.score}</td>
        </tr>
        </table>
    `
);
export const generatePanoramasMessage = (features, LngLat) => {
    const lat = LngLat ? LngLat.lat : '';
    const lng = LngLat ? LngLat.lng : '';
    const yandexLink = LngLat
        ? `https://yandex.ru/maps/?l=stv%2Csta&ll=${lng},${lat}&panorama%5Bdirection%5D=91.877107%2C0.000000&panorama%5Bfull%5D=true&panorama%5Bpoint%5D=${lng},${lat}&panorama%5Bspan%5D=119.176452%2C60.000000&z=19`
        : '#';
    const googleLink = LngLat
        ? `https://maps.google.com/maps?q=&layer=c&cbll=${lat},${lng}&cbp=11,90,0,0,0`
        : '#';

    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Границы города`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td class="col_val">${(typeof features[0].properties.id !== 'undefined')
        ? `<a href="${googleLink}" target="_blank"><img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google Icon" style="width: 16px; height: 16px; vertical-align: small; margin-right: 4px;">${t`Google Panorama`}</a>`
        : '-'}</td>
            </tr>
            <tr>
                <td class="col_val">
                    ${(typeof features[0].properties.id !== 'undefined')
            ? `<a href="${yandexLink}" target="_blank"><img src="https://upload.wikimedia.org/wikipedia/commons/5/58/Yandex_icon.svg" alt="Yandex Icon" style="width: 16px; height: 16px; vertical-align: small; margin-right: 4px;">${t`Yandex Panorama`}</a>`
            : '-'}
                </td>
            </tr>
        </table>
    `;
};

export const dynamicTariffH3ScoreMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Динамический тариф`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
            <td>${t`IX`}</td>
            <td class="col_val">${(typeof features[0].properties.ix == 'undefined') ? '-' : features[0].properties.ix}</td>
        </tr>
        <tr>
        <td>${t`Score`}</td>
        <td class="col_val">${(typeof features[0].properties.score == 'undefined') ? '-' : features[0].properties.score}</td>
        </tr>
        </table>
    `
);
export const generateClusteredAlertsMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Агрегированные алерты`}
        </strong></td>
    </tr>
        <table class="popup">
        <tr>
            <td>${t`HEX ID`}</td>
            <td class="col_val">${(typeof features[0].properties.hex_id == 'undefined') ? '-' : features[0].properties.hex_id}</td>
        </tr>
        <tr>
            <td>${t`Количество попыток`}</td>
            <td class="col_val">${(typeof features[0].properties.n_attempts == 'undefined') ? '-' : features[0].properties.n_attempts}</td>
        </tr>
        <tr>
        <td>${t`Тип попытки`}</td>
            <td class="col_val">
                ${(() => {
        const permission = features[0].properties.permission;
        const matchingPermission = AlertsTypesFilterValues.find(item => item.value === permission);

        if (matchingPermission) {
            return matchingPermission.label;
        }
        return '-';
    })()}
            </td>
        </tr>
        <tr>
        <td>${t`Тип девайса`}</td>
        <td class="col_val">
            ${(() => {
        const permission = features[0].properties.parking_choice;
        const matchingPermission = AlertsDeviceTypesFilterValues.find(item => item.value === permission);

        if (matchingPermission) {
            return matchingPermission.label;
        }
        return '-';
    })()}
        </td>
        </tr>
        </table>
    `
);

export const aggStartAugustPopup = features => {
    const properties = features[0].properties;
    const yearLabels = [ 2021, 2022, 2023, 2024, 2025, 2026 ];
    const trackValues = [
        properties.n_trips_2021,
        properties.n_trips_2022,
        properties.n_trips_2023,
        properties.n_trips_2024,
        properties.n_trips_2025,
        properties.n_trips_2026,
    ];
    const calcPercentageDifference = (current, previous) => {
        if (previous === 0) return 0; // Avoid division by zero
        const diff = ((current - previous) / previous) * 100;
        if (isNaN(diff) || !isFinite(diff)) return 0; // Return 0 if NaN or Infinity
        return `${diff.toFixed(2)}%`; // Return percentage with two decimal places
    };
    const percentageDifferences = trackValues.map((value, index) => {
        if (index === 0) return 0; // No previous year for 2021
        return calcPercentageDifference(value, trackValues[index - 1]);
    });
    const rows = [
        {
            name: t`Количество стартов`,
            values: trackValues,
        },
        {
            name: t`Разница к пред. году в %`,
            values: percentageDifferences,
        },
    ];
    const allZero = arr => arr.every(value => Number(value) === 0 || value === 'N/A');
    const nonZeroRows = rows.filter(row => !allZero(row.values));
    const tableRows = nonZeroRows.map(row => (
            `<tr class="mapboxgl-popup-content-row">
                <th scope="row">${row.name}</th>
                ${row.values.map(value => `<td class="col_val">${value}</td>`).join('')}
            </tr>`
    )).join('');
    return `
    <tr>
         <td></td>
         <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
         ${t`Агрегированные старты (август)`}
         </strong></td>
     </tr>
        <div class="popup-content">
          <table cellspacing="7px">
            <thead>
              <tr>
                <th scope="col">${t`Год`}</th>
                ${yearLabels.map(year => `<th scope="col">${year}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </div>
        `;
};
export const aggFinishAugustPopup = features => {
    const properties = features[0].properties;
    const yearLabels = [ 2021, 2022, 2023, 2024, 2025, 2026 ];
    const trackValues = [
        properties.n_trips_2021,
        properties.n_trips_2022,
        properties.n_trips_2023,
        properties.n_trips_2024,
        properties.n_trips_2025,
        properties.n_trips_2026,
    ];
    const calcPercentageDifference = (current, previous) => {
        if (previous === 0) return 0;
        const diff = ((current - previous) / previous) * 100;
        if (isNaN(diff) || !isFinite(diff)) return 0;
        return `${diff.toFixed(2)}%`;
    };
    const percentageDifferences = trackValues.map((value, index) => {
        if (index === 0) return 0; // No previous year for 2021
        return calcPercentageDifference(value, trackValues[index - 1]);
    });
    const rows = [
        {
            name: t`Количество финишей`,
            values: trackValues,
        },
        {
            name: t`Разница к пред. году в %`,
            values: percentageDifferences,
        },
    ];
    const allZero = arr => arr.every(value => Number(value) === 0 || value === 'N/A');
    const nonZeroRows = rows.filter(row => !allZero(row.values));
    const tableRows = nonZeroRows.map(row => (
                `<tr class="mapboxgl-popup-content-row">
                    <th scope="row">${row.name}</th>
                    ${row.values.map(value => `<td class="col_val">${value}</td>`).join('')}
                </tr>`
    )).join('');
    return `
        <tr>
             <td></td>
             <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
             ${t`Агрегированные финиши (август)`}
             </strong></td>
         </tr>
            <div class="popup-content">
              <table cellspacing="7px">
                <thead>
                  <tr>
                    <th scope="col">${t`Год`}</th>
                    ${yearLabels.map(year => `<th scope="col">${year}</th>`).join('')}
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                </tbody>
              </table>
            </div>
            `;
};
export const generateDiffStartFinishAugustMessage = features => {
    const properties = features[0].properties;
    const yearLabels = [ 2021, 2022, 2023, 2024, 2025, 2026 ];
    const startValues = [
        properties.starts_2021,
        properties.starts_2022,
        properties.starts_2023,
        properties.starts_2024,
        properties.starts_2025,
        properties.starts_2026,
    ];
    const finishValues = [
        properties.finishes_2021,
        properties.finishes_2022,
        properties.finishes_2023,
        properties.finishes_2024,
        properties.finishes_2025,
        properties.finishes_2026,
    ];
    const calcDifference = (starts, finishes) => {
        const diff = starts - finishes;
        return `${diff}`;
    };
    const calcPercentageDifference = (starts, finishes) => {
        if (starts === 0) return 0;
        const diff = ((starts - finishes) / starts) * 100;
        if (isNaN(diff) || !isFinite(diff)) return 0;
        return `${diff.toFixed(2)}%`;
    };
    const differences = startValues.map((start, index) => calcDifference(start, finishValues[index]));
    const percentageDifferences = startValues.map((start, index) => {
        if (index === 0) return 0;
        return calcPercentageDifference(startValues[index], finishValues[index]);
    });
    const rows = [
        {
            name: t`Количество стартов`,
            values: startValues,
        },
        {
            name: t`Количество финишей`,
            values: finishValues,
        },
        {
            name: t`Разница`,
            values: differences,
        },
        {
            name: t`Разница в %`,
            values: percentageDifferences,
        },
    ];
    const allZero = arr => arr.every(value => Number(value) === 0 || value === 'N/A');
    const nonZeroRows = rows.filter(row => !allZero(row.values));
    const tableRows = nonZeroRows.map(row => (
                    `<tr class="mapboxgl-popup-content-row">
                        <th scope="row">${row.name}</th>
                        ${row.values.map(value => `<td class="col_val">${value}</td>`).join('')}
                    </tr>`
    )).join('');
    return `
            <tr>
                 <td></td>
                 <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                 ${t`Агрегированая разница стартов и финишей (август)`}
                 </strong></td>
             </tr>
                <div class="popup-content">
                  <table cellspacing="7px">
                    <thead>
                      <tr>
                        <th scope="col">${t`Год`}</th>
                        ${yearLabels.map(year => `<th scope="col">${year}</th>`).join('')}
                      </tr>
                    </thead>
                    <tbody>
                      ${tableRows}
                    </tbody>
                  </table>
                </div>
                `;
};

export const cHBstatusCount = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Среднесуточное количество переходов в CHANGE_BATTERY по парковкам`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`Среднесуточное количество статусов CHANGE_BATTERY`}</td>
                <td class="col_val">${Math.round((features[0].properties.chb_count_30days_avg) * 100) / 100}</td>
            </tr>
            <tr style='aligh:right'>
                <td>${t`Медианное количество статусов CHANGE_BATTERY за сутки`}</td>
                <td class="col_val">${features[0].properties.chb_count_30days_median}</td>
            </tr>
        </table>
    `
);

export const cHBstatusCountOperationArea = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Среднесуточное количество самокатов в статусе CHANGE_BATTERY в операционных зонах`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`Среднесуточное количество статусов CHANGE_BATTERY в операционной зоне`}</td>
                <td class="col_val">${Math.round((features[0].properties.chb_daily_operation_zone) * 100) / 100}</td>
            </tr>
        </table>
    `
);

export const scootersSpeedMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Медианная скорость (вчера)`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`Медианная скорость Whoosh за вчерашний день`}</td>
                <td class="col_val">${Number(features[0].properties.speed_median).toFixed(1)}</td>
            </tr>
            <tr>
                <td>${t`Неровность дороги`} (${t`медиана RI`})</td>
                <td class="col_val">${Number(features[0].properties.ri_median).toFixed(2)}</td>
            </tr>
            <tr>
                <td>${t`Всего значений`}</td>
                <td class="col_val">${Number(features[0].properties.count)}</td>
            </tr>
        </table>
    `
);

export const roadIndexMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Неровность дороги (вчера)`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`Медианный Road Index за вчерашний день`}</td>
                <td class="col_val">${Number(features[0].properties.ri_median).toFixed(2)}</td>
            </tr>
            <tr>
                <td>${t`Скорость Whoosh (медиана)`}</td>
                <td class="col_val">${Number(features[0].properties.speed_median).toFixed(1)}</td>
            </tr>
            <tr>
                <td>${t`Всего значений`}</td>
                <td class="col_val">${Number(features[0].properties.count)}</td>
            </tr>
        </table>
    `
);
export const scootersCountDeficit = features => {
    const p = features[0].properties;
    const getVal = key => (typeof p[key] === 'undefined' || p[key] === null) ? '-' : p[key];
    const statusRow = (label, key) => {
        const val = p[key];
        if (!val || val <= 0) return '';
        return `
            <tr>
                <td style="padding-left: 1em;">${label}</td>
                <td class="col_val">${val}</td>
            </tr>`;
    };
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Количество самокатов на парковках`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${getVal('parking_id')}</td>
            </tr>
            <tr>
                <td>${t`Количество самокатов на парковке`}</td>
                <td class="col_val">${getVal('actual_count')}</td>
            </tr>
            ${statusRow(t`   - STAND_BY`, 'cnt_stand_by')}
            ${statusRow(t`   - BOOKED`, 'cnt_booked')}
            ${statusRow(t`   - CHANGE_BATTERY`, 'cnt_change_battery')}
            ${statusRow(t`   - NOT_READY`, 'cnt_not_ready')}
            <tr>
                <td>${t`Вместимость`}</td>
                <td class="col_val">${getVal('capacity')}</td>
            </tr>
            <tr>
                <td>${t`Заполненность на текущий момент`}</td>
                <td class="col_val">${getVal('actual_count')}/${getVal('capacity')}</td>
            </tr>
        </table>
    `;
};

export const parkingsDowntime48hMessage = features => {
    // Step 1: Convert the string to a list of objects
    const parsedData = features[0].properties.devices_info.split(', ').slice(0, 6).map(item => {
        const [ deviceId, code, hours, group ] = item.trim().split('|');
        return { deviceId, code, hours, group };
    });
    // Step 2: Create the table rows
    const tableRows = parsedData.map(row => (
    `<tr>
      <td class="col_val">${row.deviceId}</td>
      <td class="col_val">${row.code}</td>
      <td class="col_val">${row.hours}</td>
    </tr>`
    )).join('');
    // Step 3: Check if there are more than 5 values
    const additionalText = parsedData.length > 5
        ? `<p>${t`+ еще`} ${Number(features[0].properties.n_devices) - 5} ${t`шт.`}</p>`
        : '';

    // Combine everything into the final HTML
    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Простой самокатов (48+ ч)`}
            </strong></td>
        </tr>
        <table class="popup">
        <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Внутренний ID`}</td>
                <td class="col_val">${(typeof features[0].properties.internal_id == 'undefined') ? '-' : features[0].properties.internal_id}</td>
            </tr>
            <tr>
                <td style="font-weight: bold; font-size: 1.2em;">${t`Количество девайсов`}</td>
                <td class="col_val" style="font-weight: bold; font-size: 1.2em;"> ${(typeof features[0].properties.n_devices == 'undefined') ? '-' : features[0].properties.n_devices}
            </td>
            </tr>
        </table>
        <table>
            <tr>
                <th>${t`ID девайса`}</th>
                <th>${t`Код девайса`}</th>
                <th>${t`Часов простоя`}</th>
            </tr>
            ${tableRows}
        </table>
        ${additionalText}
    `;
};

export const generateParkingAlertsMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Агрегированные алерты по парковкам`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Статус парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.permission == 'undefined') ? '-' : features[0].properties.permission}</td>
            </tr>
            <tr>
                <td>${t`Попыток по данному статусу`}</td>
                <td class="col_val">${(typeof features[0].properties.cnt == 'undefined') ? '-' : features[0].properties.cnt}</td>
            </tr>
            <tr>
                <td>${t`Попыток по всем статусам`}</td>
                <td class="col_val">${(typeof features[0].properties.ttl_attempts == 'undefined') ? '-' : features[0].properties.ttl_attempts}</td>
            </tr>
            <tr>
                <td>${t`Доля DENIED`}</td>
                <td class="col_val">${(typeof features[0].properties.perc_denied == 'undefined') ? '-' : features[0].properties.perc_denied}</td>
            </tr>
            <tr>
                <td>${t`Доля LIMITED`}</td>
                <td class="col_val">${(typeof features[0].properties.perc_limited == 'undefined') ? '-' : features[0].properties.perc_limited}</td>
            </tr>
            <tr>
                <td>${t`Доля PERMITTED`}</td>
                <td class="col_val">${(typeof features[0].properties.perc_permitted == 'undefined') ? '-' : features[0].properties.perc_permitted}</td>
            </tr>
            <tr>
                <td>${t`PERMITTED радиус`}</td>
                <td class="col_val">${(typeof features[0].properties.permitted_radius == 'undefined') ? '-' : features[0].properties.permitted_radius}</td>
            </tr>
            <tr>
                <td>${t`LIMITED радиус`}</td>
                <td class="col_val">${(typeof features[0].properties.limited_radius == 'undefined') ? '-' : features[0].properties.limited_radius}</td>
            </tr>
        </table>
    `
);

export const generateParkingBookingsMessage = features => (
    `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Бронирование самокатов на парковке`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${(typeof features[0].properties.parking_id == 'undefined') ? '-' : features[0].properties.parking_id}</td>
            </tr>
            <tr>
                <td>${t`Бронирований`}</td>
                <td class="col_val">${(typeof features[0].properties.ttl_booked == 'undefined') ? '-' : features[0].properties.ttl_booked}</td>
            </tr>
            <tr>
                <td>${t`Бронирований в регионе`}</td>
                <td class="col_val">${(typeof features[0].properties.region_sum == 'undefined') ? '-' : features[0].properties.region_sum}</td>
            </tr>
            <tr>
                <td>${t`% от бронирований в регионе`}</td>
                <td class="col_val">${(typeof features[0].properties.region_share == 'undefined') ? '-' : features[0].properties.region_share}</td>
            </tr>
        </table>
    `
);

export const generateStartsByHourMessage = (features, selectedHour = 9) => {
    const props = features[0]?.properties || {};
    const hourKey = `cnt_${selectedHour}`;
    // Форматируем дату и час в формате 2025-10-06 09:00
    const date = props.date ? props.date : '-';
    const dateTime = date !== '-' ? `${date} ${String(selectedHour).padStart(2, '0')}:00` : '-';
    // Если parking_id <= 0, выводим прочерк (это fallback-запись без парковки)
    // Примечание: без promoteId значение parking_id декодируется из sint64 корректно со знаком
    const parkingId = (typeof props.parking_id !== 'undefined' && props.parking_id > 0) ? props.parking_id : '-';
    return `
        <table class="popup">
            <tr><td colspan="2"><strong>${t`Старты по часам`}</strong></td></tr>
            <tr><td>${t`id парковки`}</td><td class="col_val">${parkingId}</td></tr>
            <tr><td>${t`Индекс h3`}</td><td class="col_val">${props.h3 ?? '-'}</td></tr>
            <tr><td>${t`Дата время`}</td><td class="col_val">${dateTime}</td></tr>
            <tr><td>${t`Число поездок`}</td><td class="col_val">${props[hourKey] ?? '-'}</td></tr>
        </table>
    `;
};

// DA-14933 — попап треков исполнителей.
// Клик может попасть на несколько сегментов разных смен — группируем по shift_id,
// показываем список смен в этой точке + кнопку подсветки всей смены.
// Для кликнутых сегментов разбираем activity_json (самокаты и действия на сегменте).
export const generateScrTracksMessage = features => {
    const roleLabel = role => {
        if (role === 'ranger') return t`Рейнджер`;
        if (role === 'service_car') return t`Сервисная машина`;
        if (role === 'charger') return t`Зарядка АКБ`;
        if (role === 'coordinator') return t`Координатор`;
        return role || '-';
    };
    // Группировка по смене
    const shifts = new Map();
    features.forEach(f => {
        const p = f.properties || {};
        const sid = p.shift_id;
        if (typeof sid === 'undefined' || sid === null) return;
        if (!shifts.has(sid)) {
            shifts.set(sid, {
                shiftId: sid,
                employeeName: p.employee_name ?? '-',
                employeeUserId: p.employee_user_id ?? '-',
                roleTarget: p.role_target,
                shiftStart: p.shift_start ?? '-',
                shiftEnd: p.shift_end ?? '-',
            });
        }
    });

    const blocks = Array.from(shifts.values()).map(sh => {
        return `
            <table class="popup" style="margin-bottom:8px;">
                <tr><td colspan="2"><strong>${sh.employeeName}</strong></td></tr>
                <tr><td>${t`Смена`}</td><td class="col_val">${sh.shiftId}</td></tr>
                <tr><td>${t`Период`}</td><td class="col_val">${sh.shiftStart} — ${sh.shiftEnd}</td></tr>
                <tr><td>${t`Роль`}</td><td class="col_val">${roleLabel(sh.roleTarget)}</td></tr>
                <tr>
                    <td colspan="2" style="padding-top:6px;">
                        <button type="button" class="scr-details-btn" data-shift-id="${sh.shiftId}" data-role="${sh.roleTarget ?? ''}" data-name="${sh.employeeName}" data-period="${sh.shiftStart} — ${sh.shiftEnd}" data-role-label="${roleLabel(sh.roleTarget)}">
                            ${t`Детали смены`}
                        </button>
                    </td>
                </tr>
            </table>`;
    }).join('');

    if (!blocks) {
        return `<table class="popup"><tr><td>${t`Нет данных по смене`}</td></tr></table>`;
    }
    return `
        <div>
            <strong>${t`Треки исполнителей`}</strong>
            ${blocks}
        </div>`;
};

// Подпись действия с самокатом по флагам этапа 12 (battery_swapped / service_scooter / active_ride / cargo),
// если готовая label не пришла. Незнакомый action_label рендерится как есть.
const scrActivityLabel = it => {
    if (it.label) return it.label;
    if (it.battery_swapped) return t`замена батареи`;
    if (it.service_scooter) return t`служебный самокат`;
    if (it.active_ride) return t`транспорт исполнителя`;
    if (it.cargo) return t`перевозка`;
    return it.action_label ?? '-';
};
// Скор достоверности события (event_conf, 0..1, этап 8a): бейдж с цветом
// зелёный(1.0)→жёлтый(0.5)→красный(≤0.2). Низкий = кандидат на ручную проверку, не брак.
const scrConfBadge = it => {
    const c = Number(it && it.event_conf);
    if (!Number.isFinite(c)) return '';
    const color = c >= 0.8 ? '#2e7d32' : c >= 0.5 ? '#f9a825' : '#c62828';
    return ` <span style="color:${color};font-weight:600;">(${c.toFixed(2)})</span>`;
};
// Причина снижения скора (conf_reason, этап 8a): приглушённая подпись под действием.
// «без понижающих факторов» — дефолт без снижения, не показываем (шум).
const scrConfReason = it => {
    const r = it && it.conf_reason;
    if (typeof r !== 'string' || !r.trim() || r === 'без понижающих факторов') return '';
    return `<div style="font-size:0.85em;">${r}</div>`;
};
// Список самокатов «Кxxxx — действие (скор)» (+ причина снижения) из массива
// {device_code, action_label, label, ...флаги, event_conf, conf_reason}.
const scrScooterRows = items => {
    if (!items || items.length === 0) {
        return `<tr><td colspan="2" class="col_val" style="color:#999;">${t`нет манипуляций`}</td></tr>`;
    }
    return items.map(it => `
        <tr>
            <td class="col_val">${it.code ?? it.device_code ?? '?'}</td>
            <td class="col_val">${scrActivityLabel(it)}${scrConfBadge(it)}${scrConfReason(it)}</td>
        </tr>`).join('');
};

// Попап клика по сегменту трека в режиме смены: самокаты, с которыми работали на сегменте.
export const generateScrSegmentMessage = (features, shiftId) => {
    const seg = features.find(f => (f.properties || {}).shift_id === shiftId) || features[0];
    if (!seg) return null;
    const p = seg.properties || {};
    let activity = [];
    try {
        const arr = JSON.parse(p.activity_json || '[]');
        if (Array.isArray(arr)) activity = arr;
    } catch (e) { /* битый json — пропускаем */ }
    const hhmm = ts => (typeof ts === 'string' && ts.length >= 16 ? ts.slice(11, 16) : '-');
    // Если перемещение «пешком/самокат» и в данных есть служебный самокат — исполнитель ехал
    // именно на нём: показываем «Режим самокат (KB311M)», а из списка манипуляций его убираем.
    const svc = p.transit_mode === 'пешком/самокат'
        ? activity.find(it => it.service_scooter) : null;
    if (svc) activity = activity.filter(it => it !== svc);
    const modeText = svc
        ? `${t`самокат`} (${svc.code ?? svc.device_code ?? '?'})`
        : p.transit_mode;
    const legRow = p.transit_mode
        ? `<tr><td>${t`Режим`}</td><td class="col_val">${modeText}</td></tr>`
        : '';
    // Скорость на ребре: 0 для стоячих операций ('на месте'), иначе seg_len_m / dur_s.
    const lenM = Number(p.seg_len_m);
    const durS = Number(p.dur_s);
    let speed = null;
    if (p.transit_mode === 'на месте') speed = 0;
    else if (Number.isFinite(lenM) && Number.isFinite(durS) && durS > 0) speed = (lenM / durS) * 3.6;
    const speedRow = speed !== null
        ? `<tr><td>${t`Скорость`}</td><td class="col_val">${speed.toFixed(1)} ${t`км/ч`}</td></tr>`
        : '';
    // Раздел с самокатами показываем только если после отсева служебного что-то осталось.
    const scooterSection = activity.length > 0
        ? `<tr><td colspan="2" style="padding-top:4px;"><strong style="font-size:0.85em;">${t`Самокаты на сегменте`}</strong></td></tr>
            ${scrScooterRows(activity)}`
        : '';
    return `
        <table class="popup" style="margin-bottom:4px;">
            <tr><td colspan="2"><strong>${t`Сегмент`}</strong></td></tr>
            <tr><td>${t`Время`}</td><td class="col_val">${hhmm(p.ts_from)} — ${hhmm(p.ts_to)}</td></tr>
            ${legRow}
            ${speedRow}
            ${scooterSection}
        </table>`;
};

// Попап клика по точке-отсечке: время, парковка, манипуляции с самокатами с двух сторон точки.
export const generateScrPointMessage = features => {
    const f = features && features[0];
    if (!f) return null;
    let data = {};
    try { data = JSON.parse((f.properties || {}).scrPoint || '{}') } catch (e) { data = {} }
    const parkingRow = data.parking
        ? `<tr><td>${t`Парковка`}</td><td class="col_val">${data.parking}</td></tr>`
        : '';
    return `
        <table class="popup" style="margin-bottom:4px;">
            <tr><td colspan="2"><strong>${t`Точка`} ${data.time || ''}</strong></td></tr>
            ${parkingRow}
            <tr><td colspan="2" style="padding-top:4px;"><strong style="font-size:0.85em;">${t`Манипуляции с самокатами`}</strong></td></tr>
            ${scrScooterRows(data.scooters)}
        </table>`;
};

// Попап клика по точке инфраструктуры (слой scr_infra). Заголовок — что это за объект
// (парковка №id / СЦ / склад / зарядка) + name. Если точка совпала с ключевой точкой
// выбранной смены (payload из реестра scrKeyPointRegistry) — добавляем её атрибуты:
// время и манипуляции с самокатами.
const scrInfraTitle = (kind, id, name) => {
    const label = {
        parking: t`Парковка`,
        'service_center': t`Сервисный центр`,
        warehouse: t`Временный склад`,
        'battery_cabinet': t`Зарядный шкаф`,
        'charge_station': t`Зарядная станция`,
    }[kind] || t`Инфраструктура`;
    const hasId = id !== null && typeof id !== 'undefined';
    const num = kind === 'parking' && hasId ? ` №${id}` : '';
    const nm = name ? ` — ${name}` : '';
    return `${label}${num}${nm}`;
};
export const generateScrInfraMessage = (features, keyPoint) => {
    const f = features && features[0];
    if (!f) return null;
    const p = f.properties || {};
    const keyRows = keyPoint
        ? `<tr><td>${t`Время`}</td><td class="col_val">${keyPoint.time || '-'}</td></tr>
           <tr><td colspan="2" style="padding-top:4px;"><strong style="font-size:0.85em;">${t`Манипуляции с самокатами`}</strong></td></tr>
           ${scrScooterRows(keyPoint.scooters)}`
        : '';
    return `
        <table class="popup" style="margin-bottom:4px;">
            <tr><td colspan="2"><strong>${scrInfraTitle(p.kind, p.id, p.name)}</strong></td></tr>
            ${keyRows}
        </table>`;
};

export const sbWithErrorsMessage = features => {
    const formatDuration = minutes => {
        if (typeof minutes === 'undefined' || isNaN(minutes)) return '-'; // Handle undefined or non-numeric values

        const totalMinutes = Math.floor(minutes); // Total minutes
        const days = Math.floor(totalMinutes / 1440); // Calculate days
        const hours = Math.floor((totalMinutes % 1440) / 60); // Calculate hours
        const remainingMinutes = totalMinutes % 60; // Remaining minutes

        // Format based on conditions with translation
        if (days > 0) {
            return `${days}${t`д`} ${hours}${t`ч`} ${remainingMinutes}${t`мин`}`;
        } else if (hours > 0) {
            return `${hours}${t`ч`} ${remainingMinutes}${t`мин`}`;
        }
        return `${remainingMinutes}${t`мин`}`;
    };

    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
        ${t`Самокаты с ошибками`}
        </strong></td>
    </tr>
        <table class="popup">
            <tr>
                <td>${t`ID девайса`}</td>
                <td class="col_val">${(typeof features[0].properties.device_id === 'undefined') ? '-' : features[0].properties.device_id}</td>
            </tr>
            <tr>
                <td>${t`Код девайса`}</td>
                <td class="col_val">${(typeof features[0].properties.code === 'undefined') ? '-' : features[0].properties.code}</td>
            </tr>
            <tr>
                <td>${t`Модель`}</td>
                <td class="col_val">${(typeof features[0].properties.model === 'undefined') ? '-' : features[0].properties.model}</td>
            </tr>
            <tr>
                <td>${t`Время начала ошибки (UTC)`}</td>
                <td class="col_val">${(typeof features[0].properties.error_start_time === 'undefined') ? '-' : features[0].properties.error_start_time}</td>
            </tr>
            <tr>
                <td>${t`Длительность ошибки`}</td>
                <td class="col_val">${formatDuration(features[0].properties.error_duration_minutes)}</td>
            </tr>
            <tr>
                <td>${t`Тип ошибки`}</td>
                <td class="col_val">${(typeof features[0].properties.error_value === 'undefined') ? '-' : features[0].properties.error_value}</td>
            </tr>
        </table>
    `;
};

const translateCompetitorZoneType = zoneType => {
    if (!zoneType || zoneType === '-') return '-';
    const translations = {
        'low_speed': t`Низкая скорость`,
        'mandatory_parking': t`Обязательная парковка`,
        'no_entry': t`Запрет въезда`,
        'no_parking': t`Запрет парковки`,
        'pricing': t`Ценовая зона`,
        'promotion': t`Промо-зона`,
        'restricted': t`Ограничено`,
        'riding': t`Зона катания`,
        'service': t`Сервисная зона`,
        'sidewalk': t`Тротуар`,
        'speed_limit': t`Ограничение скорости`,
        'unknown': t`Неизвестно`,
    };
    return translations[zoneType] || zoneType;
};

export const generateCompetitorsRestrictionZonesMessage = features => {
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-') return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString(i18n.locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        } catch {
            return dateStr;
        }
    };
    const renderFeatureBlock = feature => {
        const props = feature.properties;
        const getVal = key => (typeof props[key] === 'undefined' ? '-' : props[key]);
        const speedLimit = props.speed_limit;
        const additionalRows = [];
        if (props.param_name) {
            additionalRows.push(`
            <tr>
                <td>${t`Название зоны`}</td>
                <td class="col_val">${props.param_name}</td>
            </tr>
`);
        }

        if (props.param_id) {
            additionalRows.push(`
            <tr>
                <td>${t`ID зоны`}</td>
                <td class="col_val">${props.param_id}</td>
            </tr>
`);
        }

        if (props.param_rent_zone_id) {
            additionalRows.push(`
            <tr>
                <td>${t`ID зоны аренды`}</td>
                <td class="col_val">${props.param_rent_zone_id}</td>
            </tr>
`);
        }

        if (props.param_schedule_type) {
            additionalRows.push(`
            <tr>
                <td>${t`Тип расписания`}</td>
                <td class="col_val">${props.param_schedule_type}</td>
            </tr>
`);
        }

        if (props.additional_params && props.additional_params !== '-') {
            try {
                const additionalParams = typeof props.additional_params === 'string'
                    ? JSON.parse(props.additional_params)
                    : props.additional_params;
                Object.entries(additionalParams).forEach(([ key, value ]) => {
                    // city_slug — служебное производное поле (Lite), в попапе не показываем
                    if (key === 'city_slug') return;
                    if (value !== null && typeof value !== 'undefined' && value !== '') {
                        const formattedKey = key
                            .split('_')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ');
                        let formattedValue;
                        if (typeof value === 'object') {
                            formattedValue = JSON.stringify(value, null, 2);
                        } else if (typeof value === 'boolean') {
                            formattedValue = value ? t`Да` : t`Нет`;
                        } else {
                            formattedValue = value;
                        }
                        additionalRows.push(`
            <tr>
                <td>${formattedKey}</td>
                <td class="col_val">${formattedValue}</td>
            </tr>
`);
                    }
                });
            } catch (e) {
                console.warn('Failed to parse additional_params:', e);
                additionalRows.push(`
            <tr>
                <td>${t`Дополнительные параметры`}</td>
                <td class="col_val">${props.additional_params}</td>
            </tr>
`);
            }
        }

        return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Зоны ограничений конкурентов`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Оператор`}</td>
                <td class="col_val">${getVal('operator')}</td>
            </tr>
            <tr>
                <td>${t`Тип зоны`}</td>
                <td class="col_val">${translateCompetitorZoneType(props.zone)}</td>
            </tr>
            ${typeof speedLimit !== 'undefined' && Number(speedLimit) !== 0 ? `
            <tr>
                <td>${t`Ограничение скорости`}</td>
                <td class="col_val">${speedLimit}</td>
            </tr>
            ` : ''}
            ${additionalRows.join('')}
            <tr>
                <td>${t`Дата обновления зоны`}</td>
                <td class="col_val">${formatDate(getVal('date_created'))}</td>
            </tr>
        </table>
        `;
    };

    return features.map(renderFeatureBlock).join('<hr>');
};

export const speedLimitAreasMessage = features => {
    const props = features[0].properties;
    const getVal = key => (typeof props[key] === 'undefined' ? '-' : props[key]);
    const scheduleToReadable = text => {
        if (!text || text === '-') return '-';

        // Локализуемые дни недели
        const days = [
            t`Понедельник`,
            t`Вторник`,
            t`Среда`,
            t`Четверг`,
            t`Пятница`,
            t`Суббота`,
            t`Воскресенье`,
        ];
        const parts = text.split('|');

        return parts
            .map((interval, i) => `${days[i]} ${interval}`)
            .join('<br/>');
    };

    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Зоны ограничения скорости`}
            </strong></td>
        </tr>
        <table class="popup" style="text-align: left;">
            <tr>
                <td>${t`ID зоны`}</td>
                <td class="col_val">${getVal('id')}</td>
            </tr>
            <tr>
                <td>${t`Тип зоны`}</td>
                <td class="col_val">${getVal('type_')}</td>
            </tr>
            <tr>
                <td>${t`Свойства`}</td>
                <td class="col_val">${getVal('properties')}</td>
            </tr>
            <tr>
                <td>${t`Расписание`}</td>
                <td class="col_val">${scheduleToReadable(getVal('schedule'))}</td>
            </tr>
        </table>
    `;
};

export const generateRidingZonesCompetitorsMessage = features => {
    const formatDateShort = dateStr => {
        if (!dateStr || dateStr === '-') return '-';
        try {
            const date = new Date(dateStr);
            const dd = String(date.getUTCDate()).padStart(2, '0');
            const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
            const yyyy = date.getUTCFullYear();
            return `${dd}.${mm}.${yyyy}`;
        } catch {
            return dateStr;
        }
    };
    // Извлекаем данные каждой фичи в Map { rowKey -> displayValue }
    const extractRows = feature => {
        const props = feature.properties ?? {};
        const get = key => (props[key] === null || typeof props[key] === 'undefined') ? null : props[key];
        const rows = new Map();
        rows.set('operator',           get('company'));
        rows.set('fleet_size',         get('fleet_size'));
        rows.set('param_name',         get('param_name'));
        rows.set('param_id',           get('param_id'));
        rows.set('param_status',       get('param_status'));
        rows.set('param_version',      get('param_version'));
        // additional_params — динамические ключи, префикс 'ap_'
        if (props.additional_params && props.additional_params !== '-') {
            try {
                const ap = typeof props.additional_params === 'string'
                    ? JSON.parse(props.additional_params)
                    : props.additional_params;
                Object.entries(ap).forEach(([ key, value ]) => {
                    // city_slug — служебное производное поле (Lite), в попапе не показываем
                    if (key === 'city_slug') return;
                    if (value !== null && typeof value !== 'undefined' && value !== '') {
                        rows.set(`ap_${key}`, typeof value === 'object'
                            ? JSON.stringify(value, null, 2)
                            : typeof value === 'boolean' ? (value ? t`Да` : t`Нет`) : value);
                    }
                });
            } catch (e) {
                console.warn('Failed to parse additional_params:', e);
            }
        }
        rows.set('date_created',        get('date_created') ? formatDateShort(get('date_created')) : null);
        rows.set('fleet_snapshot_date', get('fleet_snapshot_date') ? formatDateShort(get('fleet_snapshot_date')) : null);
        return rows;
    };
    // Метка для отображения ключа строки
    const labelFor = key => {
        const labels = new Map([
            [ 'operator',            t`Оператор` ],
            [ 'fleet_size',          t`Размер флота` ],
            [ 'param_name',          t`Название зоны` ],
            [ 'param_id',            t`ID зоны` ],
            [ 'param_status',        t`Статус` ],
            [ 'param_version',       t`Версия` ],
            [ 'date_created',        t`Дата обновления зоны` ],
            [ 'fleet_snapshot_date', t`Дата обновления флота` ],
        ]);
        if (labels.has(key)) return labels.get(key);
        // динамический ключ ap_someKey → 'Some Key'
        return key.replace(/^ap_/, '').split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    };
    const allRows = features.map(extractRows);
    // Фиксированные ключи + динамические ap_ в порядке первого появления + хвостовые
    const fixedKeys = [ 'operator', 'fleet_size', 'param_name', 'param_id', 'param_status', 'param_version' ];
    const apKeys = [];
    allRows.forEach(rows => {
        rows.forEach((_, key) => {
            if (key.startsWith('ap_') && !apKeys.includes(key)) apKeys.push(key);
        });
    });
    const trailingKeys = [ 'date_created', 'fleet_snapshot_date' ];
    const orderedKeys = [ ...fixedKeys, ...apKeys, ...trailingKeys ];
    // Оставляем строки, где хотя бы у одной фичи есть непустое значение
    const activeKeys = orderedKeys.filter(key => allRows.some(rows => {
        const val = rows.get(key);
        return val !== null && typeof val !== 'undefined';
    }));
    // Строим строки таблицы
    const tableRows = activeKeys.map(key => {
        const cells = allRows.map(rows => {
            const val = rows.get(key);
            return `<td class="col_val">${(val !== null && typeof val !== 'undefined') ? val : '-'}</td>`;
        }).join('');
        return `
            <tr>
                <td>${labelFor(key)}</td>
                ${cells}
            </tr>`;
    }).join('');
    return `
        <strong class="col_val" style="font-size:1em;font-weight:bold;">${t`Зоны катания конкурентов`}</strong>
        <table class="popup">
            ${tableRows}
        </table>
    `;
};

export const restrictionZonesMessage = features => {
    const formatType = type => {
        const types = {
            'LIMITED': t`Зона катания`,
            'FORBIDDEN': t`Зона запрета катания`,
            'STOP_LIMIT': t`Зона запрета парковки`,
            'PERMITTED': t`Зона парковок`,
            'SPEED_LIMIT': t`Ограничение скорости`,
        };
        return types[type] || type;
    };
    const formatAllowedForType = type => {
        if (!type || type === '-' || type === 'null' || type === 'None') return '-';
        const types = {
            'ALL': t`Все типы`,
            'SCOOTER': t`Только самокаты`,
            'BICYCLE': t`Только велосипеды`,
        };
        return types[type] || type;
    };
    const formatPauseAllowed = val => {
        if (val === 'true' || val === true || val === 1 || val === '1') return t`Пауза разрешена`;
        if (val === 'false' || val === false || val === 0 || val === '0') return t`Пауза запрещена`;
        return '-';
    };
    const formatFictitious = val => {
        if (val === 'true' || val === true || val === 1 || val === '1') return t`Фиктивная (пунктир)`;
        if (val === 'false' || val === false || val === 0 || val === '0') return t`Нет`;
        return '-';
    };
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-' || dateStr === 'null' || dateStr === 'None') return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString(i18n.locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        } catch {
            return dateStr;
        }
    };
    const formatSchedule = schedule => {
        if (!schedule || schedule === '' || schedule === '-' || schedule === 'null' || schedule === 'None') return '-';

        // Формат из БД: "H:MM - H:MM|H:MM - H:MM|..." (7 записей, Пн→Вс)
        // Неактивные дни передаются как пустая строка — они фильтруются
        const days = [
            t`Понедельник`,
            t`Вторник`,
            t`Среда`,
            t`Четверг`,
            t`Пятница`,
            t`Суббота`,
            t`Воскресенье`,
        ];
        const parts = schedule.split('|');
        const result = parts
            .map((interval, i) => interval.trim() ? `${days[i] || i + 1}: ${interval.trim()}` : null)
            .filter(Boolean)
            .join('<br/>');
        return result || '-';
    };
    const renderFeatureBlock = feature => {
        const props = feature.properties;
        const getVal = key => (typeof props[key] === 'undefined' ? '-' : props[key]);
        const zoneType = getVal('type');
        const commonFields = `
            <tr>
                <td>${t`ID зоны`}</td>
                <td class="col_val">${getVal('id')}</td>
            </tr>
            <tr>
                <td>${t`Тип зоны`}</td>
                <td class="col_val">${formatType(zoneType)}</td>
            </tr>
            <tr>
                <td>${t`Фиктивная зона`}</td>
                <td class="col_val">${formatFictitious(getVal('fictitious'))}</td>
            </tr>
        `;
        let specificFields = '';

        if (zoneType === 'LIMITED') {
            // Зона катания: id, тип, дата редактирования, тип СИМ, расписание
            specificFields = `
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
            `;
        } else if (zoneType === 'PERMITTED') {
            // Зона парковок: id, тип, дата редактирования, тип СИМ, расписание
            specificFields = `
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
            `;
        } else if (zoneType === 'FORBIDDEN') {
            // Зона запрета катания: id, тип, тип СИМ, пауза, расписание, дата редактирования
            specificFields = `
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Остановка`}</td>
                    <td class="col_val">${formatPauseAllowed(getVal('pause_allowed'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
            `;
        } else if (zoneType === 'SPEED_LIMIT') {
            // Зона ограничения скорости: id, тип, тип СИМ, пауза, расписание, дата редактирования
            specificFields = `
                <tr>
                    <td>${t`Ограничение скорости`}</td>
                    <td class="col_val">${getVal('speed_limit') === 'None' || getVal('speed_limit') === 'null' ? '-' : getVal('speed_limit') + ` ${t`км/ч`}`}</td>
                </tr>
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Остановка`}</td>
                    <td class="col_val">${formatPauseAllowed(getVal('pause_allowed'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
            `;
        } else if (zoneType === 'STOP_LIMIT') {
            // Зона запрета парковки: id, тип, тип СИМ, пауза, расписание, дата редактирования
            specificFields = `
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Остановка`}</td>
                    <td class="col_val">${formatPauseAllowed(getVal('pause_allowed'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
            `;
        }

        return `
            <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Зонирование`}
                </strong></td>
            </tr>
            <table class="popup" style="text-align: left;">
                ${commonFields}
                ${specificFields}
            </table>
        `;
    };

    return features.map(renderFeatureBlock).join('<hr>');
};

export const restrictionZonesV2Message = features => {
    const formatType = type => {
        const types = {
            'LIMITED': t`Зона катания`,
            'FORBIDDEN': t`Зона запрета катания`,
            'STOP_LIMIT': t`Зона запрета парковки`,
            'PERMITTED': t`Зона парковок`,
            'SPEED_LIMIT': t`Ограничение скорости`,
        };
        return types[type] || type;
    };
    const formatAllowedForType = type => {
        if (!type || type === '-' || type === 'null' || type === 'None') return '-';
        const types = {
            'ALL': t`Все типы`,
            'SCOOTER': t`Только самокаты`,
            'BICYCLE': t`Только велосипеды`,
        };
        return types[type] || type;
    };
    const formatPauseAllowed = val => {
        if (val === 'true' || val === true || val === 1 || val === '1') return t`Пауза разрешена`;
        if (val === 'false' || val === false || val === 0 || val === '0') return t`Пауза запрещена`;
        return '-';
    };
    const formatBoolFlag = val => {
        if (val === 'true' || val === true || val === 1 || val === '1') return t`Да`;
        if (val === 'false' || val === false || val === 0 || val === '0') return t`Нет`;
        return '-';
    };
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-' || dateStr === 'null' || dateStr === 'None') return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString(i18n.locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        } catch {
            return dateStr;
        }
    };
    const formatSchedule = schedule => {
        if (!schedule || schedule === '' || schedule === '-' || schedule === 'null' || schedule === 'None') return '-';

        // Формат из БД: "H:MM - H:MM|H:MM - H:MM|..." (7 записей, Пн→Вс)
        // Неактивные дни передаются как пустая строка — они фильтруются
        const days = [
            t`Понедельник`,
            t`Вторник`,
            t`Среда`,
            t`Четверг`,
            t`Пятница`,
            t`Суббота`,
            t`Воскресенье`,
        ];
        const parts = schedule.split('|');
        const result = parts
            .map((interval, i) => interval.trim() ? `${days[i] || i + 1}: ${interval.trim()}` : null)
            .filter(Boolean)
            .join('<br/>');
        return result || '-';
    };
    const renderFeatureBlock = feature => {
        const props = feature.properties;
        const getVal = key => (typeof props[key] === 'undefined' ? '-' : props[key]);
        const zoneType = getVal('type');
        const commonFields = `
            <tr>
                <td>${t`ID зоны`}</td>
                <td class="col_val">${getVal('id')}</td>
            </tr>
            <tr>
                <td>${t`Internal ID`}</td>
                <td class="col_val">${getVal('internal_id')}</td>
            </tr>
            <tr>
                <td>${t`Тип зоны`}</td>
                <td class="col_val">${formatType(zoneType)}</td>
            </tr>
            <tr>
                <td>${t`Фиктивная зона`}</td>
                <td class="col_val">${formatBoolFlag(getVal('fictitious'))}</td>
            </tr>
            <tr>
                <td>${t`Техническая зона`}</td>
                <td class="col_val">${formatBoolFlag(getVal('technical'))}</td>
            </tr>
            <tr>
                <td>${t`Невидимая зона`}</td>
                <td class="col_val">${formatBoolFlag(getVal('invisible'))}</td>
            </tr>
            <tr>
                <td>${t`Бейдж`}</td>
                <td class="col_val">${formatBoolFlag(getVal('badge'))}</td>
            </tr>
            <tr>
                <td>${t`Причина изменения`}</td>
                <td class="col_val">${getVal('caused_by')}</td>
            </tr>
        `;
        let specificFields = '';

        if (zoneType === 'LIMITED') {
            specificFields = `
                <tr>
                    <td>${t`Дата создания`}</td>
                    <td class="col_val">${formatDate(getVal('created_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
            `;
        } else if (zoneType === 'PERMITTED') {
            specificFields = `
                <tr>
                    <td>${t`Дата создания`}</td>
                    <td class="col_val">${formatDate(getVal('created_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
            `;
        } else if (zoneType === 'FORBIDDEN') {
            specificFields = `
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Остановка`}</td>
                    <td class="col_val">${formatPauseAllowed(getVal('pause_allowed'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата создания`}</td>
                    <td class="col_val">${formatDate(getVal('created_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
            `;
        } else if (zoneType === 'SPEED_LIMIT') {
            specificFields = `
                <tr>
                    <td>${t`Ограничение скорости`}</td>
                    <td class="col_val">${getVal('speed_limit') === 'None' || getVal('speed_limit') === 'null' ? '-' : getVal('speed_limit') + ` ${t`км/ч`}`}</td>
                </tr>
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Остановка`}</td>
                    <td class="col_val">${formatPauseAllowed(getVal('pause_allowed'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата создания`}</td>
                    <td class="col_val">${formatDate(getVal('created_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
            `;
        } else if (zoneType === 'STOP_LIMIT') {
            specificFields = `
                <tr>
                    <td>${t`Тип СИМ`}</td>
                    <td class="col_val">${formatAllowedForType(getVal('allowed_for_type'))}</td>
                </tr>
                <tr>
                    <td>${t`Остановка`}</td>
                    <td class="col_val">${formatPauseAllowed(getVal('pause_allowed'))}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата создания`}</td>
                    <td class="col_val">${formatDate(getVal('created_at'))}</td>
                </tr>
                <tr>
                    <td>${t`Дата изменения`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}</td>
                </tr>
            `;
        }

        return `
            <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Зоны ограничений`}
                </strong></td>
            </tr>
            <table class="popup" style="text-align: left;">
                ${commonFields}
                ${specificFields}
            </table>
        `;
    };

    return features.map(renderFeatureBlock).join('<hr>');
};

// DA-15115: попап слоя «Фиче-зоны» (read-only, public.feature_area через martin.feature_areas_mvt)
export const featureAreasMessage = features => {
    const escapeHtml = str => String(str)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-' || dateStr === 'null' || dateStr === 'None') return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString(i18n.locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        } catch {
            return dateStr;
        }
    };
    // Схема schedule как у обычных зон (activeTimeByDay), НО значение дня может быть
    // списком из нескольких окон в день, а не только объектом — см. docs/DA-15021.md
    const formatSchedule = scheduleRaw => {
        if (!scheduleRaw || scheduleRaw === '-') return '-';
        let schedule;
        try {
            schedule = JSON.parse(scheduleRaw);
        } catch {
            return '-';
        }
        const byDay = schedule?.activeTimeByDay;
        if (!byDay) return '-';
        const days = [
            [ 'MONDAY', t`Понедельник` ],
            [ 'TUESDAY', t`Вторник` ],
            [ 'WEDNESDAY', t`Среда` ],
            [ 'THURSDAY', t`Четверг` ],
            [ 'FRIDAY', t`Пятница` ],
            [ 'SATURDAY', t`Суббота` ],
            [ 'SUNDAY', t`Воскресенье` ],
        ];
        const formatWindow = w => (w && w.active && w.from && w.to)
            ? `${w.from[0]}:${String(w.from[1]).padStart(2, '0')} - ${w.to[0]}:${String(w.to[1]).padStart(2, '0')}`
            : null;
        const lines = days
            .map(([ key, label ]) => {
                const value = byDay[key];
                const windows = Array.isArray(value) ? value : (value ? [ value ] : []);
                const formatted = windows.map(formatWindow).filter(Boolean);
                return formatted.length ? `${label}: ${formatted.join(', ')}` : null;
            })
            .filter(Boolean);
        return lines.length ? lines.join('<br/>') : '-';
    };
    const renderFeatureBlock = feature => {
        const props = feature.properties;
        const getVal = key => (typeof props[key] === 'undefined' || props[key] === null || props[key] === '' ? '-' : props[key]);
        let propertiesJson;
        try {
            propertiesJson = JSON.stringify(JSON.parse(props.properties), null, 2);
        } catch {
            propertiesJson = props.properties || '-';
        }
        const createdBy = getVal('created_by');
        const modifiedBy = getVal('modified_by');
        return `
            <tr>
                <td></td>
                <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Фиче-зона`}
                </strong></td>
            </tr>
            <table class="popup" style="text-align: left;">
                <tr>
                    <td>${t`ID`}</td>
                    <td class="col_val">${getVal('id')}</td>
                </tr>
                <tr>
                    <td>Internal ID</td>
                    <td class="col_val">${escapeHtml(getVal('internal_id'))}</td>
                </tr>
                <tr>
                    <td>${t`Название`}</td>
                    <td class="col_val">${escapeHtml(getVal('name'))}</td>
                </tr>
                <tr>
                    <td>${t`Регион`}</td>
                    <td class="col_val">${getVal('region_id')}</td>
                </tr>
                <tr>
                    <td>${t`Статус`}</td>
                    <td class="col_val">${getVal('status')}</td>
                </tr>
                <tr>
                    <td>${t`Расписание`}</td>
                    <td class="col_val" style="white-space: pre-line;">${formatSchedule(getVal('schedule'))}</td>
                </tr>
                <tr>
                    <td>${t`Создано`}</td>
                    <td class="col_val">${formatDate(getVal('created_at'))}${createdBy !== '-' ? ` (${escapeHtml(createdBy)})` : ''}</td>
                </tr>
                <tr>
                    <td>${t`Изменено`}</td>
                    <td class="col_val">${formatDate(getVal('modified_at'))}${modifiedBy !== '-' ? ` (${escapeHtml(modifiedBy)})` : ''}</td>
                </tr>
                <tr>
                    <td>${t`Свойства`}</td>
                    <td class="col_val"><pre style="white-space: pre-wrap; word-break: break-all; margin: 0; font-size: 0.85em;">${escapeHtml(propertiesJson)}</pre></td>
                </tr>
            </table>
        `;
    };
    const seen = new Set();
    const uniqueFeatures = features.filter(f => {
        const key = f.properties.id;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
    return uniqueFeatures.map(renderFeatureBlock).join('<hr>');
};

export const tileBoundariesMessage = features => {
    const props = features[0]?.properties || {};
    const label = props.label || `${props.z}/${props.x}/${props.y}`;
    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">${t`Границы тайлов`}</strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Адрес тайла`}</td>
                <td class="col_val"><strong>${label}</strong></td>
            </tr>
        </table>
    `;
};

export const generateRebalanceForecastV2Message = features => {
    const p = features[0].properties;
    const isSurplus = p.cluster === 0 || p.cluster === '0';
    const categoryLabel = isSurplus ? t`Профицит (забираем)` : t`Дефицит (привозим)`;
    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Форкаст ребаланса`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Категория`}</td>
                <td class="col_val"><strong>${categoryLabel}</strong></td>
            </tr>
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${p.parking_id ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Кластер`}</td>
                <td class="col_val">${p.cluster ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Форкаст`}</td>
                <td class="col_val">${p.forecast ?? '-'}</td>
            </tr>
        </table>
    `;
};

export const generateFactRebalanceMessage = (features, dayMode = 'period', selectedPeriod = 0) => {
    const PERIOD_LABELS = [
        t`Ночь (0–3)`, t`Ночь (3–6)`, t`Утро (6–9)`, t`Утро (9–12)`,
        t`День (12–15)`, t`День (15–18)`, t`Вечер (18–21)`, t`Вечер (21–24)`,
    ];
    const colStyle = 'text-align:center; padding: 0 6px;';
    const hStyle   = `${colStyle} font-size: 10px; color: #aaa;`;
    const p = features[0].properties;
    const fromSc      = Number(p.rebalance_from_sc)     || 0;
    const fromRanger  = Number(p.rebalance_from_ranger)  || 0;
    const fromOther   = Number(p.rebalance_from_other)   || 0;
    const fromTotal   = Number(p.rebalance_from)         || 0;
    const toSc        = Number(p.rebalance_to_sc)        || 0;
    const toRanger    = Number(p.rebalance_to_ranger)    || 0;
    const toOther     = Number(p.rebalance_to_other)     || 0;
    const toTotal     = Number(p.rebalance_to)           || 0;
    const total       = fromTotal + toTotal;
    const totalSc     = fromSc    + toSc;
    const totalRanger = fromRanger + toRanger;
    const totalOther  = fromOther  + toOther;
    // Метка периода — в day-режиме «Сутки (агрегат)», в period-режиме — из selectedPeriod
    const periodLabel = dayMode === 'day'
        ? t`Сутки (агрегат)`
        : (PERIOD_LABELS[selectedPeriod] ?? String(selectedPeriod));

    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Фактический ребаланс`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val" colspan="4">${p.parking_id ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Период`}</td>
                <td class="col_val" colspan="4">${periodLabel}</td>
            </tr>
            <tr>
                <td></td>
                <td style="${hStyle}">${t`SC`}</td>
                <td style="${hStyle}">${t`Ranger`}</td>
                <td style="${hStyle}">${t`Other`}</td>
                <td style="${hStyle}">${t`Всего`}</td>
            </tr>
            <tr>
                <td>${t`Увезли самокатов`}</td>
                <td class="col_val" style="${colStyle}">${fromSc}</td>
                <td class="col_val" style="${colStyle}">${fromRanger}</td>
                <td class="col_val" style="${colStyle}">${fromOther}</td>
                <td class="col_val" style="${colStyle}"><strong>${fromTotal}</strong></td>
            </tr>
            <tr>
                <td>${t`Привезли самокатов`}</td>
                <td class="col_val" style="${colStyle}">${toSc}</td>
                <td class="col_val" style="${colStyle}">${toRanger}</td>
                <td class="col_val" style="${colStyle}">${toOther}</td>
                <td class="col_val" style="${colStyle}"><strong>${toTotal}</strong></td>
            </tr>
            <tr>
                <td>${t`Всего перевозок`}</td>
                <td class="col_val" style="${colStyle}">${totalSc}</td>
                <td class="col_val" style="${colStyle}">${totalRanger}</td>
                <td class="col_val" style="${colStyle}">${totalOther}</td>
                <td class="col_val" style="${colStyle}"><strong>${total}</strong></td>
            </tr>
        </table>
    `;
};

export const generateRebalanceDeltaMessage = features => {
    const p = features[0].properties;
    const isSurplus = p.cluster === 0 || p.cluster === '0';
    const categoryLabel = isSurplus ? t`Профицит (забираем)` : t`Дефицит (привозим)`;
    const taskValue = isSurplus
        ? (Number(p.cnt_scooters) || 0) - (Number(p.forecast) || 0)
        : (Number(p.forecast) || 0) - (Number(p.cnt_scooters) || 0);
    const taskLabel = isSurplus ? t`Забрать` : t`Привезти`;
    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Таба ребаланса`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Категория`}</td>
                <td class="col_val"><strong>${categoryLabel}</strong></td>
            </tr>
            <tr>
                <td>${t`ID парковки`}</td>
                <td class="col_val">${p.parking_id ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Кластер`}</td>
                <td class="col_val">${p.cluster ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Форкаст`}</td>
                <td class="col_val">${p.forecast ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Самокатов на парковке`}<br>(в статусе 'STAND_BY')</td>
                <td class="col_val">${p.cnt_scooters ?? '-'}</td>
            </tr>
            <tr>
                <td><strong>${taskLabel}</strong></td>
                <td class="col_val"><strong>${taskValue}</strong></td>
            </tr>
        </table>
    `;
};

// DA-15432: детали изменения атрибутов парковки конкурента — «атрибут: было → стало».
//
// Шумовые ключи исключены тем же списком, что в загрузчике (common/scd2.py:
// _PARKINGS_NOISE_KEYS) и в SQL (martin.parking_props_signature): по ним версия не
// создаётся, и показывать их как изменение нельзя — иначе в попапе будет мелькать
// занятость парковки. Для парковок с гео-ключом сюда же уходит внешний id: у таких
// операторов он пересоздаётся на неподвижной точке.
const PARKING_NOISE_KEYS = [
    'source', 'city_id',
    'countBikes', 'countScooters', 'isEmpty',
    'objects_count', 'currentVehicles',
    'city', 'map_pin_key',
];
const parseParkingProps = raw => {
    if (!raw || raw === '-') return null;
    try {
        return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch (e) {
        console.warn('Failed to parse parkings changes params:', e);
        return null;
    }
};
const formatParkingAttrValue = value => {
    if (value === null || typeof value === 'undefined' || value === '') return '—';
    if (typeof value === 'boolean') return value ? t`Да` : t`Нет`;
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
};
export const buildParkingAttrDiffRows = props => {
    const current = parseParkingProps(props.additional_params);
    const previous = parseParkingProps(props.prev_additional_params);
    if (!current || !previous) return [];
    const noise = [ ...PARKING_NOISE_KEYS ];
    if (String(props.entity_key || '').startsWith('geom:')) noise.push('id');
    const keys = [ ...new Set([ ...Object.keys(previous), ...Object.keys(current) ]) ]
        .filter(key => !noise.includes(key))
        .filter(key => JSON.stringify(previous[key]) !== JSON.stringify(current[key]));
    if (keys.length === 0) return [];
    return [ `
            <tr>
                <td colspan="2"><strong>${t`Что изменилось`}</strong></td>
            </tr>
` ].concat(keys.map(key => {
        const label = key.split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        return `
            <tr>
                <td>${label}</td>
                <td class="col_val">${formatParkingAttrValue(previous[key])} → ${formatParkingAttrValue(current[key])}</td>
            </tr>
`;
    }));
};

// Попап для слоя "Изменения парковок (конкуренты)" (DA-15432)
// Кроме атрибутов парковки показывает тип изменения и — для «предположительно
// удалена» — сколько прогонов парсера парковка не появлялась в данных.
export const generateCompetitorsParkingsChangesMessage = features => {
    const props = features[0].properties;
    const getVal = key => (typeof props[key] === 'undefined' || props[key] === null || props[key] === '' ? '-' : props[key]);
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-') return '-';
        try {
            return new Date(dateStr).toLocaleDateString(i18n.locale, {
                year: 'numeric', month: 'long', day: 'numeric',
            });
        } catch {
            return dateStr;
        }
    };
    const CHANGE_TYPE_LABELS = {
        'new': t`Новая парковка`,
        'presumed_deleted': t`Предположительно удалена`,
        'moved': t`Парковка перемещена`,
        'attrs_changed': t`Изменены атрибуты`,
    };
    const changeType = getVal('change_type');
    const isDeleted = changeType === 'presumed_deleted';
    const geomMoved = props.geom_moved === true || props.geom_moved === 'true';
    const rows = [];
    rows.push(`
            <tr>
                <td>${t`Оператор`}</td>
                <td class="col_val">${getVal('operator')}</td>
            </tr>
            <tr>
                <td>${t`Город`}</td>
                <td class="col_val">${getVal('city')}</td>
            </tr>
            <tr>
                <td>${t`Тип изменения`}</td>
                <td class="col_val">${CHANGE_TYPE_LABELS[changeType] || changeType}</td>
            </tr>
`);
    if (isDeleted) {
        rows.push(`
            <tr>
                <td>${t`Не появлялась с`}</td>
                <td class="col_val">${formatDate(getVal('valid_to'))}</td>
            </tr>
            <tr>
                <td>${t`Пропущено проверок`}</td>
                <td class="col_val">${getVal('missed_runs')}</td>
            </tr>
`);
    } else {
        rows.push(`
            <tr>
                <td>${t`Дата изменения`}</td>
                <td class="col_val">${formatDate(getVal('valid_from'))}</td>
            </tr>
`);
    }
    if (changeType === 'attrs_changed' || changeType === 'moved') {
        rows.push(...buildParkingAttrDiffRows(props));
    }
    if (geomMoved) {
        // Расстояние переезда: у части операторов это единственное, что изменилось
        // (точка парковки Yandex — центроид кластера), поэтому без него попап
        // выглядел бы пустым.
        const distance = getVal('move_distance_m');
        rows.push(`
            <tr>
                <td>${t`Парковка переехала`}</td>
                <td class="col_val">${distance === '-' ? t`Да` : `${distance} ${t`м`}`}</td>
            </tr>
`);
    }
    if (getVal('param_name') !== '-') {
        rows.push(`
            <tr>
                <td>${t`Название`}</td>
                <td class="col_val">${getVal('param_name')}</td>
            </tr>
`);
    }
    if (getVal('param_radius') !== '-') {
        rows.push(`
            <tr>
                <td>${t`Радиус, м`}</td>
                <td class="col_val">${getVal('param_radius')}</td>
            </tr>
`);
    }
    if (getVal('param_type') !== '-') {
        rows.push(`
            <tr>
                <td>${t`Тип парковки`}</td>
                <td class="col_val">${getVal('param_type')}</td>
            </tr>
`);
    }
    rows.push(`
            <tr>
                <td>ID</td>
                <td class="col_val">${getVal('param_id')}</td>
            </tr>
`);

    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Изменения парковок конкурентов`}
            </strong></td>
        </tr>
        <table class="popup user_geojson_popup">
            ${rows.join('')}
        </table>
    `;
};

// Попап для слоя "Парковки (конкуренты)" (DA-13627)
// Выводит operator, city, date_created и динамически все поля из properties (jsonb → additional_params)
export const generateCompetitorsParkingsMessage = features => {
    const props = features[0].properties;
    const operatorDisplayNames = {
        SmartBike: 'Smart Bike',
    };
    const getVal = key => (typeof props[key] === 'undefined' || props[key] === null ? '-' : props[key]);
    const getOperatorLabel = op => operatorDisplayNames[op] || op;
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-') return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString(i18n.locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        } catch {
            return dateStr;
        }
    };
    // Динамически разворачиваем additional_params (сериализованный jsonb из properties)
    const additionalRows = [];
    if (props.additional_params && props.additional_params !== '-') {
        try {
            const additionalParams = typeof props.additional_params === 'string'
                ? JSON.parse(props.additional_params)
                : props.additional_params;

            Object.entries(additionalParams).forEach(([ key, value ]) => {
                if (value !== null && typeof value !== 'undefined' && value !== '') {
                    const formattedKey = key
                        .split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    let formattedValue;
                    if (typeof value === 'object') {
                        formattedValue = JSON.stringify(value, null, 2);
                    } else if (typeof value === 'boolean') {
                        formattedValue = value ? t`Да` : t`Нет`;
                    } else {
                        formattedValue = value;
                    }
                    additionalRows.push(`
            <tr>
                <td>${formattedKey}</td>
                <td class="col_val">${formattedValue}</td>
            </tr>
`);
                }
            });
        } catch (e) {
            console.warn('Failed to parse additional_params (competitors_parkings):', e);
            additionalRows.push(`
            <tr>
                <td>${t`Дополнительные параметры`}</td>
                <td class="col_val">${props.additional_params}</td>
            </tr>
`);
        }
    }

    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Парковки конкурентов`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Оператор`}</td>
                <td class="col_val">${getOperatorLabel(getVal('operator'))}</td>
            </tr>
            <tr>
                <td>${t`Город`}</td>
                <td class="col_val">${getVal('city')}</td>
            </tr>
            ${additionalRows.join('')}
            <tr>
                <td>${t`Дата обновления`}</td>
                <td class="col_val">${formatDate(getVal('date_created'))}</td>
            </tr>
        </table>
    `;
};

export const generateRegToTripConversionMessage = features => {
    const props = features[0].properties;
    const share = props.share;
    const shareFormatted = (typeof share === 'undefined' || share === null)
        ? '-'
        : `${Math.round(share * 100)}%`;
    const totalDevices = (typeof props.total_devices === 'undefined') ? '-' : props.total_devices;
    const devicesWithTrip = (typeof props.devices_with_trip === 'undefined') ? '-' : props.devices_with_trip;

    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Конверсия из регистраций в старты`}
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`Конверсия`}</td>
            <td class="col_val"><strong>${shareFormatted}</strong></td>
        </tr>
        <tr>
            <td>${t`Новых пользователей`}</td>
            <td class="col_val">${totalDevices}</td>
        </tr>
        <tr>
            <td>${t`Совершили старт`}</td>
            <td class="col_val">${devicesWithTrip}</td>
        </tr>
        <tr>
            <td>${t`Уровень детализации`}</td>
            <td class="col_val">H3-${props.zoom ?? '-'}</td>
        </tr>
    </table>
    `;
};

// DA-13054: Административные границы OSM
export const generateOsmAdminBoundariesMessage = features => {
    const renderFeatureBlock = feature => {
        const props = feature.properties ?? {};
        return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
                ${t`Административное деление`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Название`}</td>
                <td class="col_val">${props.name ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Название (en)`}</td>
                <td class="col_val">${props.name_en ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Название (ru)`}</td>
                <td class="col_val">${props.name_ru ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Уровень (admin_level)`}</td>
                <td class="col_val">${props.admin_level ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`OSM ID`}</td>
                <td class="col_val">${props.osm_id ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`Код ISO`}</td>
                <td class="col_val">${props.iso_code ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`ID города`}</td>
                <td class="col_val">${props.city_id ?? '-'}</td>
            </tr>
            <tr>
                <td>${t`ID региона`}</td>
                <td class="col_val">${props.region_id ?? '-'}</td>
            </tr>
        </table>
        `;
    };
    return features.map(renderFeatureBlock).join('<hr>');
};

// DA-13776: Сетка гексагонов H3
export const generateH3GridMessage = features => {
    if (!features || !features.length) return '';
    const props = features[0].properties;
    return `
    <div class="popup-content">
      <table class="popup">
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Ячейка сетки H3`}
            </strong></td>
        </tr>
        <tr>
            <td>${t`H3 zoom`}</td>
            <td class="col_val">${props.h3_zoom ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`H3 index`}</td>
            <td class="col_val">${props.h3_index ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`H3 int8`}</td>
            <td class="col_val">${props.h3_int8 ?? '-'}</td>
        </tr>
      </table>
    </div>
    `;
};

// DA-12966: попап для слоя «Агрегированные потери»
export const generateLostDevicesH3Message = features => {
    const props = features[0]?.properties ?? {};
    const zoom = props.zoom ?? '-';
    const cntDeleted     = props.cnt_deleted      ?? 0;
    const cntLostCurrent = props.cnt_lost_current ?? 0;
    const cntLostFound   = props.cnt_lost_found   ?? 0;
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Агрегированные потери`} (zoom ${zoom})
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`LOST — все потери`}</td>
            <td class="col_val"><strong>${cntLostCurrent}</strong></td>
        </tr>
        <tr>
            <td>${t`LOST&FOUND — впоследствии найдены`}</td>
            <td class="col_val">${cntLostFound}</td>
        </tr>
        <tr>
            <td>${t`DELETED — утрачены безвозвратно`}</td>
            <td class="col_val">${cntDeleted}</td>
        </tr>
    </table>
    `;
};

// DA-14308: Выбросы GPS-треков по H3-гексагонам
// src: 'all' | 'gps' | 'lbs' | 'phone_gps' | 'ble_s'
export const routeAnomaliesH3Message = (features, src = 'all', period = '1d') => {
    const props = features[0]?.properties ?? {};
    const suffix = src === 'all' ? 'all' : src;
    const cnt = props[`cnt_${suffix}`] ?? null;
    const median = props[`median_dist_${suffix}`] ?? null;
    const cntFmt = cnt !== null ? cnt : '—';
    const medFmt = median !== null ? `${median} ${t`м`}` : '—';
    const srcLabels = { all: 'ALL', gps: 'GPS', lbs: 'LBS', 'phone_gps': 'PHONE_GPS', 'ble_s': 'BLE_S' };
    const srcLabel = srcLabels[src] ?? src;
    const tilePeriod = props.period ?? period;
    const periodLabels = { '1d': t`1 день`, '7d': t`7 дней`, '30d': t`30 дней`, 'all': t`Весь период` };
    const periodLabel = periodLabels[tilePeriod] ?? tilePeriod;
    const bins = [
        { key: `cnt_${suffix}_lt_10`,       label: t`< 10 м` },
        { key: `cnt_${suffix}_d_10_25`,      label: t`10–25 м` },
        { key: `cnt_${suffix}_d_25_50`,      label: t`25–50 м` },
        { key: `cnt_${suffix}_d_50_100`,     label: t`50–100 м` },
        { key: `cnt_${suffix}_d_100_250`,    label: t`100–250 м` },
        { key: `cnt_${suffix}_d_250_500`,    label: t`250–500 м` },
        { key: `cnt_${suffix}_d_500_1000`,   label: t`500–1000 м` },
        { key: `cnt_${suffix}_d_1000_2500`,  label: t`1–2.5 км` },
        { key: `cnt_${suffix}_gt_2500`,      label: t`> 2.5 км` },
    ];
    const binRows = bins
        .map(b => {
            const v = props[b.key] ?? null;
            const share = cnt ? ((v / cnt) * 100).toFixed(1) : null;
            return `<tr>
                <td>${b.label}</td>
                <td class="col_val">${v !== null ? v : '—'}</td>
                <td class="col_val" style="color:#999;">${share !== null ? share + '%' : '—'}</td>
            </tr>`;
        })
        .join('');

    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Выбросы GPS-треков (H3)`}
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`Период`}</td>
            <td class="col_val">${periodLabel}</td>
        </tr>
        <tr>
            <td>${t`Источник`}</td>
            <td class="col_val">${srcLabel}</td>
        </tr>
        <tr>
            <td>${t`Индекс H3`}</td>
            <td class="col_val">${props.h3 ?? '—'}</td>
        </tr>
        <tr>
            <td>${t`Зум`}</td>
            <td class="col_val">${props.zoom ?? '—'}</td>
        </tr>
        <tr>
            <td><strong>${t`Количество выбросов`}</strong></td>
            <td class="col_val"><strong>${cntFmt}</strong></td>
        </tr>
        <tr>
            <td><strong>${t`Медиана дистанции`}</strong></td>
            <td class="col_val"><strong>${medFmt}</strong></td>
        </tr>
        <tr>
            <td colspan="3"><hr style="margin: 4px 0; border-color: #555;"/></td>
        </tr>
        <tr>
            <th>${t`Диапазон`}</th>
            <th class="col_val">${t`Событий`}</th>
            <th class="col_val">%</th>
        </tr>
        ${binRows}
    </table>
    `;
};


// DA-14587: попап ошибок геометрии операционных/функциональных зон
export const generateAreaErrMessage = features => {
    // Объект внутри функции, чтобы t`...` вычислялся с текущей локалью при каждом вызове
    const ERROR_TYPE_LABELS = {
        'self_intersection':  t`Самопересечение`,
        'duplicate_vertex':   t`Дублированная вершина`,
        'multipolygon_part':  t`Лишняя часть мультиполигона`,
        hole:                 t`Дырка в полигоне`,
        'duplicate_feature':  t`Дубликат объекта`,
        overlap:              t`Перекрытие`,
    };
    const props = features[0]?.properties ?? {};
    const errorLabel = ERROR_TYPE_LABELS[props.error_type] ?? props.error_type;
    const detailsRow = props.err_details
        ? `<tr><th>${t`Детали`}</th><td class="col_val">${props.err_details}</td></tr>`
        : '';
    return `
    <table class="popup">
        <tr><th>${t`Тип ошибки`}</th><td class="col_val">${errorLabel}</td></tr>
        <tr><th>${t`ID объектов`}</th><td class="col_val">${props.feature_ids ?? '—'}</td></tr>
        <tr><th>${t`Слой`}</th><td class="col_val">${props.source_layer ?? '—'}</td></tr>${detailsRow}
    </table>
    `;
};

// Попап для слоя "Переброски флота (конкуренты)" (DA-13611)
// Выводит направление, оператора, даты отправки/прибытия, состав флота
export const generateCompetitorsFleetTransfersMessage = features => {
    const props = features[0].properties;
    const operatorDisplayNames = { SmartBike: 'Smart Bike' };
    const getVal = key => (typeof props[key] === 'undefined' || props[key] === null ? '-' : props[key]);
    const getOperatorLabel = op => operatorDisplayNames[op] || op;
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-') return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString(i18n.locale, { year: 'numeric', month: 'long', day: 'numeric' });
        } catch {
            return dateStr;
        }
    };
    // Разворачиваем fleet_details (jsonb)
    const fleetRows = [];
    if (props.fleet_details && props.fleet_details !== '-') {
        try {
            const details = typeof props.fleet_details === 'string'
                ? JSON.parse(props.fleet_details)
                : props.fleet_details;
            Object.entries(details).forEach(([ key, val ]) => {
                if (val !== null && typeof val !== 'undefined' && val !== '') {
                    fleetRows.push(`
            <tr>
                <td>${key}</td>
                <td class="col_val">${val}</td>
            </tr>`);
                }
            });
        } catch (e) {
            // Молча игнорируем ошибку парсинга
        }
    }

    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Переброска флота`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Оператор`}</td>
                <td class="col_val">${getOperatorLabel(getVal('operator'))}</td>
            </tr>
            <tr>
                <td>${t`Откуда`}</td>
                <td class="col_val">${getVal('city_from')}</td>
            </tr>
            <tr>
                <td>${t`Куда`}</td>
                <td class="col_val">${getVal('city_to')}</td>
            </tr>
            <tr>
                <td>${t`Расстояние`}</td>
                <td class="col_val">${getVal('distance_km')} ${t`км`}</td>
            </tr>
            <tr>
                <td>${t`Дата отправки`}</td>
                <td class="col_val">${formatDate(getVal('date'))}</td>
            </tr>
            <tr>
                <td>${t`Дата прибытия`}</td>
                <td class="col_val">${formatDate(getVal('arrival_date'))}</td>
            </tr>
            <tr>
                <td>${t`Дней в пути`}</td>
                <td class="col_val">${getVal('transit_days')}</td>
            </tr>
            <tr>
                <td>${t`Самокатов`}</td>
                <td class="col_val">${getVal('num_scooters')}</td>
            </tr>
            <tr>
                <td>${t`Велосипедов`}</td>
                <td class="col_val">${getVal('num_bicycles')}</td>
            </tr>
            <tr>
                <td>${t`Всего ТС`}</td>
                <td class="col_val"><strong>${getVal('num_vehicles')}</strong></td>
            </tr>
            ${fleetRows.join('')}
        </table>
    `;
};

// DA-14686: Попап для изменений зон конкурентов
export const generateCompetitorsZonesChangesMessage = features => {
    // Показываем только записи с record_type = 'current', чтобы не дублировать для prev_geom
    const currentFeatures = features.filter(f => f.properties?.record_type === 'current');
    const displayFeatures = currentFeatures.length > 0 ? currentFeatures : features;
    const props = displayFeatures[0].properties;
    const getVal = key => (typeof props[key] === 'undefined' || props[key] === null ? '-' : props[key]);
    const changeTypeLabels = {
        'new':           t`Новая зона`,
        'deleted':       t`Зона удалена`,
        'geom_changed':  t`Изменена геометрия`,
        'attrs_changed': t`Изменены атрибуты`,
    };
    const changeType = getVal('change_type');
    const changeTypeLabel = changeTypeLabels[changeType] || changeType;
    const formatDate = dateStr => {
        if (!dateStr || dateStr === '-') return '-';
        try {
            const date = new Date(dateStr);
            const dd = String(date.getUTCDate()).padStart(2, '0');
            const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
            const yyyy = date.getUTCFullYear();
            return `${dd}.${mm}.${yyyy}`;
        } catch {
            return dateStr;
        }
    };
    const attrsDiffRows = (() => {
        if (changeType !== 'attrs_changed') return '';
        const rows = [];
        const zoneType = props.zone_type;
        const prevZoneType = props.prev_zone_type;
        const speedLimit = props.speed_limit;
        const prevSpeedLimit = props.prev_speed_limit;
        const scheduleType = props.schedule_type;
        const prevScheduleType = props.prev_schedule_type;
        const scheduleTypeLabel = val => {
            if (val === 'SPEED_LIMIT_ACTIVE') return t`Активно`;
            if (val === 'NOT_ACTIVE') return t`Не активно`;
            return val || '-';
        };
        if (prevZoneType !== null && typeof prevZoneType !== 'undefined' && prevZoneType !== zoneType) {
            rows.push(`
            <tr>
                <td>${t`Тип зоны`}</td>
                <td class="col_val">${translateCompetitorZoneType(prevZoneType)} → ${translateCompetitorZoneType(zoneType)}</td>
            </tr>`);
        }
        if (prevSpeedLimit !== null && typeof prevSpeedLimit !== 'undefined' && prevSpeedLimit !== speedLimit) {
            rows.push(`
            <tr>
                <td>${t`Ограничение скорости`}</td>
                <td class="col_val">${prevSpeedLimit} → ${speedLimit} ${t`км/ч`}</td>
            </tr>`);
        }
        if (prevScheduleType !== null && typeof prevScheduleType !== 'undefined' && prevScheduleType !== scheduleType) {
            rows.push(`
            <tr>
                <td>${t`Режим ограничения`}</td>
                <td class="col_val">${scheduleTypeLabel(prevScheduleType)} → ${scheduleTypeLabel(scheduleType)}</td>
            </tr>`);
        }
        // Для операторов без scheduleType (Bolt, Lime и др.) — вычисляем diff из additional_params
        if (rows.length === 0 && props.additional_params_json && props.prev_additional_params_json) {
            // Ключи, которые меняются из-за артефактов парсера — не показываем
            const NOISE_KEYS = new Set([ 'source', 'city_id', 'id' ]);
            try {
                const curr = JSON.parse(props.additional_params_json);
                const prev = JSON.parse(props.prev_additional_params_json);
                const allKeys = new Set([ ...Object.keys(curr), ...Object.keys(prev) ]);
                allKeys.forEach(key => {
                    if (NOISE_KEYS.has(key)) return;
                    const oldVal = prev[key] !== null && typeof prev[key] !== 'undefined' ? prev[key] : '-';
                    const newVal = curr[key] !== null && typeof curr[key] !== 'undefined' ? curr[key] : '-';
                    if (String(oldVal) !== String(newVal)) {
                        rows.push(`
                        <tr>
                            <td>${key}</td>
                            <td class="col_val">${oldVal} → ${newVal}</td>
                        </tr>`);
                    }
                });
            } catch {
                // не удалось распарсить — продолжаем к fallback
            }
        }
        if (rows.length === 0) {
            rows.push(`
            <tr>
                <td>${t`Детали изменений`}</td>
                <td class="col_val">${t`недоступны`}</td>
            </tr>`);
        }
        return rows.join('');
    })();

    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Изменения зон`}
            </strong></td>
        </tr>
        <table class="popup">
            <tr>
                <td>${t`Оператор`}</td>
                <td class="col_val">${getVal('company')}</td>
            </tr>
            <tr>
                <td>${t`Тип изменения`}</td>
                <td class="col_val">${changeTypeLabel}</td>
            </tr>
            <tr>
                <td>${t`Тип зоны`}</td>
                <td class="col_val">${translateCompetitorZoneType(getVal('zone_type'))}</td>
            </tr>
            <tr>
                <td>${t`ID зоны`}</td>
                <td class="col_val">${getVal('zone_id')}</td>
            </tr>
            ${attrsDiffRows}
            <tr>
                <td>${t`Дата изменения`}</td>
                <td class="col_val">${formatDate(getVal('valid_from'))}</td>
            </tr>
            <tr>
                <td>${t`Дней назад`}</td>
                <td class="col_val">${getVal('days_since_change')}</td>
            </tr>
        </table>
    `;
};

// DA-14919: WalkScore — popup со всеми скорами ячейки (общий, 5 групп, 15 категорий).
export const generateWalkscoreMessage = features => {
    const p = features[0].properties;
    const v = key => p[key] ?? '—';
    const groups = [
        [ t`Образование`, 'r_1' ],
        [ t`Магазины и здравоохранение`, 'r_2' ],
        [ t`Общественное питание`, 'r_3' ],
        [ t`Досуг`, 'r_4' ],
        [ t`Спорт и рекреация`, 'r_5' ],
    ];
    const cats = [
        [ t`Детские сады`, 'kind' ],
        [ t`Школы`, 'schl' ],
        [ t`ВУЗы`, 'univ' ],
        [ t`Продукты`, 'food' ],
        [ t`Магазины`, 'shop' ],
        [ t`Медицина`, 'heal' ],
        [ t`Фастфуд`, 'fast' ],
        [ t`Кафе`, 'cafe' ],
        [ t`Рестораны`, 'rest' ],
        [ t`Кинотеатры`, 'cine' ],
        [ t`Театры/музеи`, 'thea' ],
        [ t`Развлечения`, 'entr' ],
        [ t`Зелёные зоны`, 'park' ],
        [ t`Библиотеки`, 'bibl' ],
        [ t`Спортобъекты`, 'fitn' ],
    ];
    const row = ([ label, key ]) => `<tr><td>${label}</td><td class="col_val">${v(key)}</td></tr>`;

    return `
        <table class="popup">
            <tr><td></td><td><strong class="col_val" style="font-size: 1em; font-weight: bold;">WalkScore</strong></td></tr>
            <tr><td>${t`Общий`}</td><td class="col_val"><strong>${v('r_all')}</strong></td></tr>
            <tr><td colspan="2"><strong>${t`Группы`}</strong></td></tr>
            ${groups.map(row).join('')}
            <tr><td colspan="2"><strong>${t`Категории`}</strong></td></tr>
            ${cats.map(row).join('')}
        </table>
    `;
};
// DA-13733 — подписи видов предложений по развитию сети
const chargingProposalLabel = kind => ({
    open: t`Новый объект для увеличения мощности`,
    open_walk: t`Новый объект для улучшения пешей доступности`, // eslint-disable-line camelcase -- значение kind из БД
    review: t`Проверить`,
    expand: t`Расширить станцию`,
    offload: t`Разгрузить шкаф новым объектом`,
    shrink: t`Сократить слоты`,
    close: t`Кандидат на закрытие`,
}[kind] || kind);
const chargingProposalVariant = variant => ({
    scooter: t`самокат, 15 мин`,
    plan: t`согласованный план`,
}[variant] || t`пешком, 1,5 км`);
const chargingProposalStatus = status => ({
    agreed: t`согласовано`,
    edited: t`согласовано с поправкой`,
    added: t`добавлено на согласовании`,
    question: t`на проверке`,
    no_comment: t`без комментариев`, // eslint-disable-line camelcase -- значение status из БД
}[status] || status);

// DA-13733 — попап места-кандидата на новый объект.
export const generateChargingProposalMessage = features => {
    const p = features[0].properties;
    const v = key => p[key] ?? '—';
    const rows = [
        [ t`Замен в сутки в зоне охвата`, `<strong>${v('swaps_day')}</strong>` ],
        [ t`Слотов при обороте 4`, v('slots_target') ],
        [ t`Обоснование`, v('note') ],
        ...(p.status ? [ [ t`Статус`, chargingProposalStatus(p.status) ] ] : []),
        ...(p.comment ? [ [ t`Комментарий`, p.comment ] ] : []),
        [ t`Дата расчёта`, v('calc_date') ],
    ];
    const row = ([ label, value ]) => `<tr><td>${label}</td><td class="col_val">${value}</td></tr>`;

    return `
        <table class="popup">
            <tr><td colspan="2"><strong style="font-size: 1em; font-weight: bold;">${chargingProposalLabel(p.kind)}: ${v('name')}</strong> (${chargingProposalVariant(p.variant)})</td></tr>
            ${rows.map(row).join('')}
        </table>
    `;
};

// DA-13733 — попап зарядного объекта: оборот по факту (счётчик электроэнергии или учёт зарядов)
// либо по модели, загрузка от потолка 7; источник — в скобках у загрузки.
export const generateChargingObjectsLoadMessage = (features, proposals = []) => {
    const p = features[0].properties;
    const v = key => p[key] ?? '—';
    const slots = p.slots_imputed === true || p.slots_imputed === 'true'
        ? `${v('slots')} (${t`медиана по типу`})`
        : v('slots');
    const rows = [
        [ t`Тип`, v('type') ],
        ...(p.contractor ? [ [ t`Подрядчик`, p.contractor ] ] : []),
        [ t`Слотов`, slots ],
        [ t`Загрузка от потолка 7 зарядов на слот, %`, `<strong>${v('util_pct')}</strong> (${v('util_source')})` ],
        [ t`Оборот по факту, зарядов на слот в сутки`, v('turnover_fact') ],
        [ t`Зарядов в сутки по факту`, v('charges_day') ],
        [ t`Нагрузка по пешей модели, АКБ в сутки`, v('load_walk_day') ],
        [ t`Оборот по модели, зарядов на слот в сутки`, v('turnover_model') ],
        [ t`Дата расчёта`, v('calc_date') ],
    ];
    const row = ([ label, value ]) => `<tr><td>${label}</td><td class="col_val">${value}</td></tr>`;

    return `
        <table class="popup">
            <tr><td colspan="2"><strong style="font-size: 1em; font-weight: bold;">${v('name')}</strong></td></tr>
            ${rows.map(row).join('')}
            ${proposals.map(pr => `<tr><td colspan="2"><strong>${chargingProposalLabel(pr.kind)}</strong> (${chargingProposalVariant(pr.variant)}${pr.status ? `, ${chargingProposalStatus(pr.status)}` : ''}): ${pr.note}${pr.comment ? `<br/>${t`Комментарий`}: ${pr.comment}` : ''}</td></tr>`).join('')}
        </table>
    `;
};
// DA-15040 — попап ДТП с участием СИМ (ГИБДД). Показываем атрибуты инцидента; при наличии
// детей-участников — агрегат (число, диапазон возрастов). Сырые даты рождения не выводятся.
export const generateSimAccidentMessage = features => {
    const p = features[0]?.properties || {};
    const dash = v => (typeof v === 'undefined' || v === null || v === '' ? '-' : v);
    // Адрес: округ, улица, дом (что есть).
    const addr = [ p.okrug, p.street, p.house ].filter(Boolean).join(', ') || dash(p.place_path);
    const rows = [];
    const add = (label, val) => { if (typeof val !== 'undefined' && val !== null && val !== '' && val !== '-') rows.push(`<tr><td>${label}</td><td class="col_val">${val}</td></tr>`); };
    add(t`Дата, время`, dash(p.accident_ts));
    add(t`Вид ДТП`, dash(p.accident_type));
    add(t`Оператор`, dash(p.operator));
    add(t`ИНЗ`, dash(p.inz));
    add(t`Нарушитель`, dash(p.offender));
    add(t`Нарушение`, dash(p.main_violation));
    add(t`Погибло`, dash(p.killed));
    add(t`Ранено`, dash(p.injured));
    add(t`Ранено детей до 18`, dash(p.injured_children_u18));
    add(t`Дети за рулём`, p.children_driving === true || p.children_driving === 'true' ? t`да` : null);
    // Агрегат по детям-участникам (без дат рождения).
    if (Number(p.n_children) > 0) {
        const ages = (p.child_min_age && p.child_max_age && p.child_min_age !== p.child_max_age)
            ? `${p.child_min_age}–${p.child_max_age}` : dash(p.child_min_age);
        add(t`Детей-участников`, `${p.n_children} (${t`возраст`} ${ages})`);
        add(t`из них ранено`, dash(p.n_children_injured));
    }
    add(t`Зона`, dash(p.zone_ring));
    add(t`Освещение`, dash(p.lighting));
    add(t`Погода`, dash(p.weather));
    add(t`Адрес`, dash(addr));
    return `
        <table class="popup">
            <tr><td colspan="2"><strong>${t`ДТП с участием СИМ`}</strong></td></tr>
            ${rows.join('')}
        </table>
    `;
};

// DA-15309: попапы слоя «Типология застройки» — общие подписи классов для зданий и территорий
const urbanTypologyClassLabel = value => {
    const BLDG_CLASS_LABELS = {
        'residential_individual': t`Индивидуальные жилые дома`,
        'residential_multi': t`Многоквартирные жилые дома`,
        commercial: t`Коммерческая застройка`,
        industrial: t`Промышленно-коммунальная застройка`,
        campus: t`Кампусы и учебные заведения`,
        education: t`Образование и воспитание`,
        healthcare: t`Здравоохранение`,
        // DA-15202: green_park не было в словаре — попап показывал сырое 'green_park'.
        // Подписи и порядок совпадают с легендой (UrbanTypologyLegend.jsx): у зданий
        // green_park не встречается, лишняя строка словарю не мешает.
        'green_park': t`Благоустроенное озеленение`,
        green: t`Зелёные территории`,
        sport: t`Спорт`,
        'transport_hub': t`Транспортные хабы`,
        service: t`Служебные постройки`,
        'прочее': t`Прочее`,
        unclassified: t`Не классифицировано`,
    };
    if (!value) return t`Не классифицировано`;
    return BLDG_CLASS_LABELS[value] ?? value;
};
const urbanTypologySourceLabel = value => {
    const SOURCE_LABELS = {
        osm: 'OSM',
        footprint: 'Google/Microsoft Open Buildings',
    };
    return value ? (SOURCE_LABELS[value] ?? value) : '-';
};
const urbanTypologyLevelsSourceLabel = value => {
    const LEVELS_SOURCE_LABELS = {
        osm: 'OSM',
        measured: t`Измерено`,
        'median_region_class': t`Медиана по региону и классу`,
    };
    return value ? (LEVELS_SOURCE_LABELS[value] ?? value) : '-';
};
const urbanTypologyPopulationSourceLabel = value => {
    const POPULATION_SOURCE_LABELS = {
        census: t`Перепись`,
        registry: t`Реестр`,
        'modeled_provision': t`Модель (обеспеченность)`,
        measured: t`Измерено`,
    };
    return value ? (POPULATION_SOURCE_LABELS[value] ?? value) : '-';
};

export const generateUrbanTypologyBuildingMessage = features => {
    const p = features[0]?.properties || {};
    const dash = v => (typeof v === 'undefined' || v === null || v === '' ? '-' : v);
    return `
        <table class="popup">
            <tr><td colspan="2"><strong>${t`Здание`}</strong></td></tr>
            <tr><td>${t`Класс`}</td><td class="col_val">${urbanTypologyClassLabel(p.bldg_class)}</td></tr>
            <tr><td>${t`Источник данных`}</td><td class="col_val">${urbanTypologySourceLabel(p.source)}</td></tr>
            <tr><td>${t`Источник класса`}</td><td class="col_val">${dash(p.class_source)}</td></tr>
            <tr><td>${t`Причина класса`}</td><td class="col_val">${dash(p.class_reason)}</td></tr>
            <tr><td>${t`Площадь, м²`}</td><td class="col_val">${p.area_m2 ? Math.round(p.area_m2).toLocaleString(i18n.locale) : '-'}</td></tr>
            <tr><td>${t`Этажность`}</td><td class="col_val">${dash(p.levels)}</td></tr>
            <tr><td>${t`Источник этажности`}</td><td class="col_val">${urbanTypologyLevelsSourceLabel(p.levels_source)}</td></tr>
            <tr><td>${t`Население`}</td><td class="col_val">${dash(p.population)}</td></tr>
            <tr><td>${t`Источник населения`}</td><td class="col_val">${urbanTypologyPopulationSourceLabel(p.population_source)}</td></tr>
            <tr><td>${t`ID здания`}</td><td class="col_val">${dash(p.building_id)}</td></tr>
            <tr><td>${t`ID квартала`}</td><td class="col_val">${dash(p.block_id)}</td></tr>
            <tr><td>${t`Регион`}</td><td class="col_val">${dash(p.region_id)}</td></tr>
        </table>
    `;
};

// DA-15433 — предложения по парковкам.
// «Величина спроса» — уникальные ПОЛЬЗОВАТЕЛИ, а не сырые алерты: ранги кластеров по этим
// метрикам расходятся, и встречаются кластеры вида «58 алертов = одна поездка одного
// человека» (повторные нажатия кнопки). Алерты и поездки показываем рядом для контекста.
export const generateParkingProposalMessage = features => {
    const p = features[0]?.properties || {};
    const dash = v => (typeof v === 'undefined' || v === null || v === '' ? '-' : v);
    const num = v => (typeof v === 'number' ? v.toLocaleString(i18n.locale) : dash(v));
    const oversized = p.is_oversized === true || p.is_oversized === 'true';
    return `
        <table class="popup">
            <tr><td colspan="2"><strong>${t`Предложение по парковке`}</strong></td></tr>
            <tr><td>${t`Величина спроса (человек)`}</td><td class="col_val">${num(p.demand)}</td></tr>
            <tr><td>${t`Место по спросу в городе`}</td><td class="col_val">${
    Number.isFinite(Number(p.demand_pct)) ? `${t`верхние`} ${Math.round((1 - Number(p.demand_pct)) * 100)}%` : '-'
}</td></tr>
            <tr><td>${t`Алертов`}</td><td class="col_val">${num(p.alerts_cnt)}</td></tr>
            <tr><td>${t`Поездок`}</td><td class="col_val">${num(p.trips_cnt)}</td></tr>
            <tr><td>${t`Дней со спросом`}</td><td class="col_val">${dash(p.days_cnt)}</td></tr>
            <tr><td>${t`Алертов за 7 дней`}</td><td class="col_val">${num(p.alerts_recent)}</td></tr>
            <tr><td>${t`До ближайшей парковки, м`}</td><td class="col_val">${dash(p.median_distance_m)}</td></tr>
            <tr><td>${t`Площадь, м²`}</td><td class="col_val">${num(p.area_m2)}</td></tr>
            <tr><td>${t`Поперечник, м`}</td><td class="col_val">${dash(p.diameter_m)}</td></tr>
            <tr><td>${t`Регион`}</td><td class="col_val">${dash(p.region_name)}</td></tr>
            ${oversized ? `<tr><td colspan="2"><em>${t`Слишком крупный кластер — боль размазана по кварталу, точечная парковка её не решает`}</em></td></tr>` : ''}
        </table>
    `;
};

export const generateUrbanTypologyZoneMessage = features => {
    const p = features[0]?.properties || {};
    const dash = v => (typeof v === 'undefined' || v === null || v === '' ? '-' : v);
    // zone_source собирается из ЗНАЧЕНИЙ ТЕГОВ OSM, то есть из произвольного пользовательского
    // текста, и уходит прямо в разметку попапа — экранируем.
    const esc = v => String(v ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;');
    return `
        <table class="popup">
            <tr><td colspan="2"><strong>${t`Территория`}</strong></td></tr>
            <tr><td>${t`Класс`}</td><td class="col_val">${urbanTypologyClassLabel(p.bldg_class)}</td></tr>
            <tr><td>${t`Происхождение`}</td><td class="col_val">${p.zone_source ? esc(p.zone_source) : '-'}</td></tr>
            <tr><td>${t`Вид разреза`}</td><td class="col_val">${dash(p.origin)}</td></tr>
            <tr><td>${t`Зданий в территории`}</td><td class="col_val">${dash(p.n_buildings)}</td></tr>
            <tr><td>${t`Площадь, м²`}</td><td class="col_val">${p.area_m2 ? Math.round(p.area_m2).toLocaleString(i18n.locale) : '-'}</td></tr>
            <tr><td>${t`Регион`}</td><td class="col_val">${dash(p.region_id)}</td></tr>
            <tr><td>city_id</td><td class="col_val">${dash(p.city_id)}</td></tr>
            <tr><td>zone_id</td><td class="col_val">${dash(p.zone_id)}</td></tr>
        </table>
    `;
};

// Попап пользовательского GeoJSON-слоя: показываем все свойства фичи как есть —
// структура файла произвольна, ничего осмысленного о ней заранее не известно.
export const userGeoJsonMessage = (features, layerName) => {
    // Содержимое файла — произвольное пользовательское, экранируем всё, что уходит в HTML
    const escapeHtml = str => String(str ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;');
    const props = features[0]?.properties || {};
    const rows = Object.entries(props)
        .map(([ key, value ]) => `
            <tr>
                <td>${escapeHtml(key)}</td>
                <td class="col_val">${escapeHtml(value)}</td>
            </tr>
        `)
        .join('');
    return `
        <tr>
            <td></td>
            <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">${escapeHtml(layerName)}</strong></td>
        </tr>
        <table class="popup">
            ${rows || `<tr><td>${t`Свойства отсутствуют`}</td><td></td></tr>`}
        </table>
    `;
};

// DA-16000: точка доступа Wi-Fi из базы, собранной по сканам самокатов.
// r_m — разброс наблюдений вокруг вычисленной координаты, он же радиус неуверенности
// в позиции; ms7 — доля наблюдений в модальной H3-ячейке километрового масштаба,
// признак стационарности (в базе только точки с ms7 ≥ 0.8).
export const generateWifiApMessage = features => {
    const props = features[0]?.properties ?? {};
    const fmtDate = value => (value ? String(value).slice(0, 10) : '-');
    const rmRaw = props.r_m ?? null;
    const ms7Raw = props.ms7 ?? null;
    const rm = rmRaw !== null ? `${Math.round(Number(rmRaw))} ${t`м`}` : '-';
    const ms7 = ms7Raw !== null ? `${Math.round(Number(ms7Raw) * 100)}%` : '-';
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Точка доступа Wi-Fi`}
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`MAC`}</td>
            <td class="col_val"><strong>${props.mac ?? '-'}</strong></td>
        </tr>
        <tr>
            <td>${t`Наблюдений`}</td>
            <td class="col_val"><strong>${props.n_obs ?? '-'}</strong></td>
        </tr>
        <tr>
            <td>${t`Разными самокатами`}</td>
            <td class="col_val">${props.n_imei ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`Разброс наблюдений`}</td>
            <td class="col_val">${rm}</td>
        </tr>
        <tr>
            <td>${t`В модальной ячейке`}</td>
            <td class="col_val">${ms7}</td>
        </tr>
        <tr>
            <td>${t`Первое наблюдение`}</td>
            <td class="col_val">${fmtDate(props.first_seen)}</td>
        </tr>
        <tr>
            <td>${t`Последнее наблюдение`}</td>
            <td class="col_val">${fmtDate(props.last_seen)}</td>
        </tr>
    </table>
    `;
};

// DA-16000: H3-ячейка слоя «Плотность покрытия».
// zoom приходит атрибутом тайла — это уровень H3, на котором посчитан агрегат.
export const generateWifiApH3Message = features => {
    const props = features[0]?.properties ?? {};
    const rAvgRaw = props.r_avg ?? null;
    const rAvg = rAvgRaw !== null ? `${Math.round(Number(rAvgRaw))} ${t`м`}` : '-';
    const cntAp = Number(props.cnt_ap ?? 0);
    const obsTotal = Number(props.obs_total ?? 0);
    const perAp = cntAp > 0 ? Math.round(obsTotal / cntAp) : '-';
    return `
    <tr>
        <td></td>
        <td><strong class="col_val" style="font-size: 1em; font-weight: bold;">
            ${t`Плотность покрытия`} (zoom ${props.zoom ?? '-'})
        </strong></td>
    </tr>
    <table class="popup">
        <tr>
            <td>${t`Точек доступа`}</td>
            <td class="col_val"><strong>${props.cnt_ap ?? '-'}</strong></td>
        </tr>
        <tr>
            <td>${t`Наблюдений всего`}</td>
            <td class="col_val">${props.obs_total ?? '-'}</td>
        </tr>
        <tr>
            <td>${t`Наблюдений на точку`}</td>
            <td class="col_val">${perAp}</td>
        </tr>
        <tr>
            <td>${t`Средний разброс`}</td>
            <td class="col_val">${rAvg}</td>
        </tr>
    </table>
    `;
};
